export default {
  /**
   * Kiểu dữ liệu cột trong mẫu bảng lương
   */
  DataTypeColumnTemplateSalary: {
    Amount: 'Số tiền',
    Text: 'Chữ',
    Rate: 'Tỷ lệ',
    Coefficient: 'Hệ số',
  },

  /**
   * Số thuế phải nộp trên tờ khai điều chỉnh tăng/giảm:
   */
  TaxPayable: {
    GTGTDomesticProductionAndTrading:
      '1701 - Thuế giá trị gia tăng hàng sản xuất, kinh doanh trong nước (gồm cả dịch vụ trong lĩnh vực dầu khí)',
    GTGTImport: '1702 - Thuế giá trị gia tăng hàng nhập khẩu',
    GTGTOilExplorationAndProduction:
      '1704 - Thuế giá trị gia tăng từ hoạt động thăm dò và khai thác dầu, khí (gồm cả thuế giá trị gia tăng thu đối với dầu, khí khai thác theo hiệp định, hợp đồng thăm dò, khai thác dầu, khí bán ra trong nước)',
    GTGTLottery: '1705 - Thuế giá trị gia tăng từ hoạt động xổ số kiến thiết',
    OtherService: '1749 - Hàng hóa, dịch vụ khác',
  },

  /**
   * Số thuế phải nộp trên tờ khai thuế thu nhập doanh nghiệp điều chỉnh tăng/giảm:
   * NHANH3 08.04.2024
   */
  EnterpriseIncomeTaxPayable: {
    TNDNBusiness:
      '1052 - Thuế thu nhập doanh nghiệp từ hoạt động sản xuất kinh doanh (gồm cả dịch vụ trong lĩnh vực dầu khí)',
    TNDNProperty: '1053 - Thuế thu nhập doanh nghiệp từ chuyển nhượng bất động sản',
    TNDNTransfer: '1055 - Thuế thu nhập doanh nghiệp từ hoạt động chuyển nhượng vốn',
    TNDNOil:
      '1056 - Thuế thu nhập doanh nghiệp từ hoạt động thăm dò và khai thác dầu, khí (không kể thuế thu nhập doanh nghiệp thu theo hiệp định, hợp đồng thăm dò khai thác dầu khí)',
    TNDNLottery: '1057 - Thuế thu nhập doanh nghiệp từ hoạt động xổ số kiến thiết',
    TNDNOther: '1099 - Khác',
  },

  /**
   * Số thuế đề nghị hoàn điều chỉnh tăng/giảm:
   */
  TaxRefund: {
    TaxRefundGTGT: '7551 - Hoàn thuế giá trị gia tăng',
    LateRefund:
      '7552 - Trả lãi do chậm hoàn trả thuế giá trị gia tăng; thuế tiêu thụ đặc biệt; thuế nhập khẩu theo chương trình ưu đãi thuế công nghiệp hỗ trợ',
    TaxRefundConsume:
      '7553 - Hoàn thuế tiêu thụ đặc biệt mặt hàng xăng khoáng nguyên liệu dùng để sản xuất, pha chế xăng sinh học theo Luật thuế tiêu thụ đặc biệt',
    TaxRefundImportCar: '7554 - Hoàn thuế nhập khẩu đối với chương trình ưu đãi thuế sản xuất, lắp ráp ô tô',
    TaxRefundSupportingIndustry: '7555 - Hoàn thuế nhập khẩu đối với chương trình ưu đãi thuế công nghiệp hỗ trợ',
    OtherRefund: '7599 - Hoàn khác',
  },

  /**
   * Vai trò quyền hạn
   */
  RoleAction: {
    Add: 'Thêm',
    View: 'Sử dụng',
    Edit: 'Sửa',
    Delete: 'Xóa',
    Posted: 'Ghi sổ',
    UnPost: 'Bỏ ghi',
    Print: 'In',
    ReleaseEInvoice: 'Phát hành hóa đơn điện tử',
    SendInvoice: 'Gửi hóa đơn cho khách hàng',
    ConvertIntoPaperVoucher: 'Chuyển thành chứng từ giấy',
    DownloadInvoice: 'Tải hóa đơn',
    CancelInvoice: 'Hủy hóa đơn',
    SettingLayout: 'Ẩn/hiện cột',
  },

  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Thêm',
    QuickAdd: 'Thêm nhanh',
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác',
  },
  InDebt: {
    Debt: 'Dư nợ',
    ExcessYes: 'Dư có',
  },

  Operator: {
    And: 'Và',
    Or: 'Hoặc',
  },
  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  FilterOperatorSearch: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu bằng',
    EndsWith: 'Kết thúc bằng',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  OrganizationUnitType: {
    Corporations: 'Tổng công ty',
    Group: 'Tập đoàn',
    Subsidiaries: 'Công ty con',
    Branch: 'Chi nhánh',
    Representative: 'Văn phòng đại điện',
    Office: 'Văn phòng',
    Center: 'Trung tâm',
    Department: 'Phòng ban',
    Team: 'NHóm/tổ/đội',
    Factory: 'Phân xưởng',
  },
  EmployeeType: {
    Probation: 'Thử việc',
    Office: 'Chính thức',
    Manage: 'Quản lý',
  },
  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: '6 tháng đầu năm',
    SixLastMonth: '6 tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },

  PeriodDashboard: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    ThisMonth: 'Tháng này',
    ThisYear: 'Năm nay',
    Custom: 'Tùy chọn',
  },

  // Chỉ lấy số của tháng (vqphong - 19/10/2022)
  PeriodMonth: {
    January: '1',
    February: '2',
    March: '3',
    April: '4',
    May: '5',
    June: '6',
    July: '7',
    August: '8',
    September: '9',
    October: '10',
    November: '11',
    December: '12',
  },
  AccountCategoryKind: {
    Debit: 'Dư Nợ',
    Credit: 'Dư Có',
    BothSide: 'Lưỡng tính',
  },
  Currency: {
    VND: 'VND',
    Dola: 'USD',
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi trên 1 trang',
    Twen: '20 bản ghi trên 1 trang',
    Thir: '30 bản ghi trên 1 trang',
    Fif: '50 bản ghi trên 1 trang',
    Hunder: '100 bản ghi trên 1 trang',
  },
  SalaryForm: {
    Coefficient: 'Hệ số',
    Amount: 'Số tiền',
  },
  MethodDistributeType: {
    Budget: 'Dự toán',
    TreasuryWarrant: 'Lệnh chi',
    InKind: 'Hiện vật',
    RecordReceiptExpense: 'Ghi thu - Ghi chi',
    Other: 'Khác',
  },
  SortReportAccountingVoucherList: {
    desc: 'Giảm dần',
    asc: 'Tăng dần',
  },
  SortData: {
    DESC: 'Giảm dần',
    ASC: 'Tăng dần',
  },
  CashWithDrawType: {
    None: 'Không chọn',
    EstimateAdvance: 'Tạm ứng đã cấp dự toán',
    EstimateNotYetAdvance: 'Tạm ứng chưa cấp dự toán',
    AdvancePayment: 'Thanh toán tạm ứng',
    Expense: 'Thực chi', // sửa theo comment của a tú
    PlanReceipt: 'Nhận dự toán',
    TreasuryWarrantReceipt: 'Nhận lệnh chi tạm ứng',
    ReceiptExpense: 'Ghi thu - Ghi chi',
    TreasuryWarrantReceiptExpense: 'Nhận lệnh chi thực chi',
    ExpenseReduce: 'Giảm chi - Thực chi',
    ExpenseReduceAdvance: 'Giảm chi - Tạm ứng',
    RefundExpense: 'Nộp trả - Thực chi',
    RefundAdvance: 'Nộp trả - Tạm ứng',
    Supplement: 'Bổ sung',
    RestoreExpense: 'Nộp phục hồi - Thực chi',
    RestoreAdvance: 'Nộp phục hồi - Tạm ứng',
    BudgetRejecttion: 'Xuất toán',
    ReceiptBudgetReturn: 'Giảm thu',
    IncrementAdjustment: 'Điều chỉnh tăng thuế GTGT',
    DecrementAdjustment: 'Điều chỉnh giảm thuế GTGT',
    DestroyPlanning: 'Hủy dự toán',
    BUPlanAdjustment: 'Điều chỉnh',
    DestroyReceipt: 'Hủy lệnh chi tiền',
    ReceiptForInferior: 'Lệnh chi cho cấp dưới',
    ReceivedReceiptFromSuperiors: 'Lệnh chi nhận từ cấp trên',
  },
  SalagovReftype: {
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    BAWithDrawSalary: 'Tiền gửi',
    CAPaymentSalary: 'Tiền mặt',
  },
  Fee: {
    FeeByUserSender: 'Phí người chuyển chịu',
    FeeByShare: 'Phí chia sẻ 2 bên',
    FeeByUserReceiver: 'Phí người hưởng chịu',
  },

  RefType: {
    BUTransfer: 'Chuyển khoản kho bạc',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào TK tiền gửi',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanReceipt: 'Nhận dự toán đầu năm',
    BUPlanReceiptSuplementary: 'Nhận dự toán bổ sung',
    CAReceiptSale: 'Phiếu thu bán hàng',
    CAReceipt: 'Phiếu thu',
    CAReceiptWithdraw: 'Phiếu thu rút tiền gửi NH, KB',
    CAReceiptPlanWithdraw: 'Phiếu thu rút dự toán nhập quỹ',
    CAReceiptFixedAsset: 'Phiếu thu bán TSCĐ',
    BUPlanSupplement: 'Nhận dự toán bổ sung',
    BUPlanCancel: 'Hủy dự toán',
    BUVoucherListPlanned: 'Bảng kê chứng từ thanh toán đã cấp dự toán',
    BUVoucherListNotPlanned: 'Bảng kê chứng từ thanh toán chưa cấp dự toán',
    BUVoucherListReceipExpense: 'Bảng kê chứng từ thanh toán ghi thu - ghi chi',
    BUVoucherListOther: 'Bảng kê chứng từ khác',
    BUVoucherListRealExpense: 'Bảng kê chứng từ thanh toán thực chi',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    SUTransfer: 'Điều chuyển CCDC',
    SUIncrement: 'Ghi tăng CCDC',
    SUDecrement: 'Ghi giảm CCDC',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    PUInvoice: 'Mua hàng chưa thanh toán',
    INTransfer: 'Chuyển kho',
    INAdjustment: 'Điều chỉnh tồn kho',
    INOutward: 'Xuất kho',
    INInward: 'Nhập kho',
    BADeposit: 'Thu tiền gửi',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh tạm ứng',
    BURealExpenseAdjustment: 'Điều chỉnh thực chi',
    CAPaymentVendor: 'Phiếu chi trả nhà cung cấp',
    CAPaymentPurchase: 'Phiếu chi mua vật tư hàng hóa',
    SAInvoice: 'Bán hàng chưa thu tiền',
    BABankTransfer: 'Chuyển tiền nội bộ',
    BAWithdrawPurchase: 'Chi tiền gửi mua Vật tư, hàng hóa',
    CAPayment: 'Phiếu chi',
    CAPaymentDeposit: 'Phiếu chi nộp vào NH, KB',
    CAPaymentSalary: 'Phiếu chi trả lương',
    CAPaymentFixedAsset: 'Phiếu chi mua tài sản cố định',
    BAWithDraw: 'Chi tiền gửi',
    GLGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    BUBudgetReserve: 'Dự toán giữ lại',
    GLBeginningYearTransfer: 'Quyết toán số dư đầu năm',
    CAReceiptCustomer: 'Phiếu thu tiền khách hàng',
    GLProfitLossTransfer: 'Xác định kết quả hoạt động',
    GLEndYearTransfer: 'Kết chuyển số dư cuối năm',
    GLPayrollExpense: 'Hạch toán chi phí lương',
    GLProvisionalTaxInComeEnterprise: 'Tạm tính thuế thu nhập doanh nghiệp',
    GLFinalTaxInComeEnterprise: 'Quyết toán thuế thu nhập doanh nghiệp',
    SAReturn: 'Hàng bán trả lại',
    BUCommitmentRequest: 'Đề nghị cam kết chi',
    BUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    GLVoucherSummaryTable: 'Bảng tổng hợp chứng từ cùng loại',
    GLPostedVoucher: 'Chứng từ ghi sổ',
    BATransferDeposit: 'Tiền chuyển đến',
    BATransferWithdraw: 'Tiền chuyển đi',
    FAAdjustment: 'Đánh giá lại TSCĐ',
    FAVoucherDepreciation: 'Hao mòn TSCĐ từ MISA QLTS',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ MISA QLTS',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ MISA QLTS',
    FAVoucherDepreciate: 'Khấu hao TSCĐ từ MISA QLTS',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ MISA QLTS',
    FADevaluation: 'Trích khấu hao tài sản cố định',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount: 'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount: 'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    BADepositSale: 'Thu tiền gửi từ bán hàng',
    BADepositCustomer: 'Thu tiền gửi từ khách hàng',
    BUOpeningCommitment: 'CKC ban đầu',
    BAWithdrawVendor: 'Chi tiền gửi trả nhà cung cấp',
    BUTransferVendorPayment: 'Chuyển khoản kho bạc trả nhà cung cấp',
    BUTransferSalary: 'Chuyển khoản kho bạc trả lương',
    BUTransferInsurrance: 'Chuyển khoản kho bạc thanh toán bảo hiểm',
    BUTransferFixedAsset: 'Chuyển khoản kho bạc mua tài sản cố định',
    BUTreasuryFundTransferSalary: 'Chuyển khoản trả lương',
    BUTreasuryFundTransferInsurancePayment: 'Chuyển khoản thanh toán bảo hiểm',
    BAWithDrawSalary: 'Chi tiền gửi trả lương',
    BAWithDrawFixedAsset: 'Chi tiền gửi mua tài sản cố định',
    SASaleInvoice: 'Hóa đơn',
    FASaleInvoice: 'Bán TSCĐ chưa thu tiền',
    BADepositFixedAsset: 'Thu tiền gửi bán TSCĐ',
    SASaleInvoiceAdjustIncrement: 'Hóa đơn điều chỉnh',
    SaleInvoiceReplace: 'Hóa đơn thay thế',
    SASaleInvoiceAdjustDecrement: 'Hóa đơn điều chỉnh giảm',
    SASaleInvoiceAdjustInfo: 'Hóa đơn điều chỉnh thông tin',
    SaleInvoiceCancel: 'Hóa đơn hủy',
    SAElectronicTicket: 'Vé điện tử',
    OPChapter: 'Số dư ban đầu Chương',
    OPBudgetIndex: 'Số dư ban đầu MLNS',
    OPBudgetIndexAndProject: 'Số dư ban đầu MLNS và Dự án',
    OPBudgetSourceAndBudgetChapterAndActivity: 'Số dư ban đầu Nguồn, Chương và Hoạt động',
    OPBudgetIndexAndTaskAndBudgetChapter: 'Số dư ban đầu MLNS, Nhiệm vụ và Chương',
    OPAccoutingObjectAndBudgetChapter: 'Số dư ban đầu Chương và Đối tượng',
    OPAccoutingObjectAndBudgetSourceAndBudgetChapter: 'Số dư ban đầu Nguồn, Chương và Đối tượng',
    OPAccoutingObjectAndProjectAndBudgetChapter: 'Số dư ban đầu Chương, Đối tượng và Dự án',
    OPAccoutingObjectAndTaskAndBudgetChapter: 'Số dư ban đầu Chương, Đối tượng và Nhiệm vụ',
    OPInventoryAndBudgetChapter: 'Số dư ban đầu Chương và Vật tư',
    OPSupplyAndBudgetChapter: 'Số dư ban đầu Chương và CCDC',
    OPFixedAssetAndBudgetChapter: 'Số dư ban đầu Chương và TSCĐ',
    OPCustomization: 'Số dư ban đầu tùy biến',
    OPInventoryAndBudgetChapterAndBudgetSource: 'Số dư ban đầu Chương, Vật tư và Nguồn',
    PAPersonalIncomeTax: 'Bảng tính thuế TNCN',
    PASalary: 'Bảng lương',
    StatisticalDayOff: 'Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm',
    PARetroSalaryIncrease: 'Bảng truy lĩnh lương',
    PARetroStandardSalaryIncrease: 'Bảng truy lĩnh lương tối thiểu',
    ReportFinancial: 'Báo cáo tài chính',
    PAOtherOutcome: 'Khấu trừ không thường xuyên',
    PAOtherIncome: 'Thu nhập không thường xuyên',
    FADecrement: 'Ghi giảm tài sản cố định',
    FAPurchaseInvoice: 'Hóa đơn mua tài sản cố định',
    FAIncrement: 'Nhận bằng hiện vật và ghi tăng',
    FADepreciation: 'Tính hao mòn tài sản cố định',
    FATransfer: 'Điều chuyển tài sản cố định',
    TAPurchaseList: 'Bảng kê thuế mua vào',
    TASaleList: 'Bảng kê thuế bán ra',
    TAVATDeclaration: 'Tờ khai thuế',
    TAEnterpriseIncomeTax: 'Tờ khai thuế thu nhập doanh nghiệp',

    // các refType fake dùng cho form Sao chép dữ liệu
    BUPlanReceiptSum: 'Nhận dự toán',
    CAReceiptPlanWithdrawCash: 'Phiếu thu rút dự toán nhập quỹ', // Phiếu thu rút dự toán nhập quỹ - phân hệ Tiền mặt
    CAReceiptWithdrawWithDraw: 'Phiếu thu rút tiền gửi NH, KB', //
    CAPaymentDepositWithDraw: 'Phiếu chi nộp vào NH, KB', //
    BUTransferPurchaseInventory: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    CAPaymentPurchaseInventory: 'Phiếu chi mua vật tư hàng hóa',
    BAWithdrawFixedAssetFix: 'Chi tiền gửi mua tài sản cố định',
    CAPaymentFixedAssetFix: 'Phiếu chi mua tài sản cố định',
    BUTransferFixedAssetFix: 'Chuyển khoản kho bạc mua tài sản cố định',
    CAReceiptFixedAssetFix: 'Phiếu thu bán TSCĐ',
    BADepositFixedAssetFix: 'Thu tiền gửi bán TSCĐ',
    BAWithdrawSalarySalary: 'Chi tiền gửi trả lương',
    BUTransferSalarySalary: 'Chuyển khoản kho bạc trả lương',
    CAPaymentSalarySalary: 'Phiếu chi trả lương',
    BAWithdrawVendorPurchase: 'Chi tiền gửi trả nhà cung cấp',
    BUTransferVendorPaymentPurchase: 'Chuyển khoản kho bạc trả nhà cung cấp',
    CAPaymentVendorPurchase: 'Phiếu chi trả nhà cung cấp',
    PUInvoicePurchase: 'Mua hàng chưa thanh toán',
    CAReceiptSaleSell: 'Phiếu thu bán hàng',
    CAReceiptFixedAssetSell: 'Phiếu thu bán TSCĐ',
    CAReceiptCustomerSell: 'Phiếu thu tiền khách hàng',
    BADepositSaleSell: 'Thu tiền gửi từ bán hàng',
    BADepositFixedAssetSell: 'Thu tiền gửi bán TSCĐ',
    BADepositCustomerSell: 'Thu tiền gửi từ khách hàng',
    BAWithdrawPurchasePurchase: 'Chi tiền gửi mua Vật tư, hàng hóa',
    FASaleInvoiceFix: 'Bán TSCĐ chưa thu tiền',
    BUTransferDepositWithDraw: 'Chuyển khoản kho bạc vào TK tiền gửi',
    BUTransferPurchasePurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    CAPaymentPurchasePurchase: 'Phiếu chi mua vật tư hàng hóa',
    BAWithdrawPurchasePurchase2: 'Chi tiền gửi mua Vật tư, hàng hóa',
    CAFundInventory: 'Bảng kiểm kê quỹ',
  },
  RefTypeVoucherSearch: {
    BUTransfer: 'Chuyển khoản kho bạc',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào TK tiền gửi',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanReceipt: 'Nhận dự toán đầu năm',
    CAReceiptSale: 'Phiếu thu bán hàng',
    CAReceipt: 'Phiếu thu',
    CAReceiptWithdraw: 'Phiếu thu rút tiền gửi NH, KB',
    CAReceiptPlanWithdraw: 'Phiếu thu rút dự toán nhập quỹ',
    CAReceiptFixedAsset: 'Phiếu thu bán TSCĐ',
    BUPlanSupplement: 'Nhận dự toán bổ sung',
    BUPlanCancel: 'Hủy dự toán',
    BUVoucherListPlanned: 'Bảng kê chứng từ thanh toán đã cấp dự toán',
    BUVoucherListNotPlanned: 'Bảng kê chứng từ thanh toán chưa cấp dự toán',
    BUVoucherListReceipExpense: 'Bảng kê chứng từ thanh toán ghi thu - ghi chi',
    BUVoucherListOther: 'Bảng kê chứng từ khác',
    BUVoucherListRealExpense: 'Bảng kê chứng từ thanh toán thực chi',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    // SUTransfer: 'Điều chuyển CCDC',
    SUIncrement: 'Ghi tăng CCDC',
    SUDecrement: 'Ghi giảm CCDC',
    PUInvoice: 'Mua hàng chưa thanh toán',
    INTransfer: 'Chuyển kho',
    INAdjustment: 'Điều chỉnh tồn kho',
    INOutward: 'Xuất kho',
    INInward: 'Nhập kho',
    BADeposit: 'Thu tiền gửi',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh tạm ứng',
    BURealExpenseAdjustment: 'Điều chỉnh thực chi',
    CAPaymentVendor: 'Phiếu chi trả nhà cung cấp',
    CAPaymentPurchase: 'Phiếu chi mua vật tư hàng hóa',
    SAInvoice: 'Bán hàng chưa thu tiền',
    BABankTransfer: 'Chuyển tiền nội bộ',
    BAWithdrawPurchase: 'Chi tiền gửi mua Vật tư, hàng hóa',
    CAPayment: 'Phiếu chi',
    CAPaymentDeposit: 'Phiếu chi nộp vào NH, KB',
    CAPaymentSalary: 'Phiếu chi trả lương',
    CAPaymentFixedAsset: 'Phiếu chi mua tài sản cố định',
    BAWithDraw: 'Chi tiền gửi',
    GLGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    BUBudgetReserve: 'Dự toán giữ lại',
    GLBeginningYearTransfer: 'Quyết toán số dư đầu năm',
    CAReceiptCustomer: 'Phiếu thu tiền khách hàng',
    GLProfitLossTransfer: 'Xác định kết quả hoạt động',
    GLEndYearTransfer: 'Kết chuyển số dư cuối năm',
    GLPayrollExpense: 'Hạch toán chi phí lương',
    GLProvisionalTaxInComeEnterprise: 'Tạm tính thuế thu nhập doanh nghiệp',
    GLFinalTaxInComeEnterprise: 'Quyết toán thuế thu nhập doanh nghiệp',
    SAReturn: 'Hàng bán trả lại',
    BUCommitmentRequest: 'Đề nghị cam kết chi',
    BUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    BATransferDeposit: 'Tiền chuyển đến',
    BATransferWithdraw: 'Tiền chuyển đi',
    FAAdjustment: 'Đánh giá lại TSCĐ',
    FAVoucherDepreciation: 'Hao mòn TSCĐ từ QLTS',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS',
    FAVoucherDepreciate: 'Khấu hao TSCĐ từ QLTS',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS',
    FADevaluation: 'Trích khấu hao tài sản cố định',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount: 'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount: 'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    BADepositSale: 'Thu tiền gửi từ bán hàng',
    BADepositCustomer: 'Thu tiền gửi từ khách hàng',
    BUOpeningCommitment: 'CKC ban đầu',
    BAWithdrawVendor: 'Chi tiền gửi trả nhà cung cấp',
    BUTransferVendorPayment: 'Chuyển khoản kho bạc trả nhà cung cấp',
    BUTransferSalary: 'Chuyển khoản kho bạc trả lương',
    BUTransferInsurrance: 'Chuyển khoản kho bạc thanh toán bảo hiểm',
    BUTransferFixedAsset: 'Chuyển khoản kho bạc mua tài sản cố định',
    BUTreasuryFundTransferSalary: 'Chuyển khoản trả lương',
    BUTreasuryFundTransferInsurancePayment: 'Chuyển khoản thanh toán bảo hiểm',
    BAWithDrawSalary: 'Chi tiền gửi trả lương',
    BAWithDrawFixedAsset: 'Chi tiền gửi mua tài sản cố định',
    FASaleInvoice: 'Bán TSCĐ chưa thu tiền',
    BADepositFixedAsset: 'Thu tiền gửi bán TSCĐ',
    FADecrement: 'Ghi giảm tài sản cố định',
    FAPurchaseInvoice: 'Hóa đơn mua tài sản cố định',
    FAIncrement: 'Nhận bằng hiện vật và ghi tăng',
    FADepreciation: 'Tính hao mòn tài sản cố định',
    // FATransfer: 'Điều chuyển tài sản cố định',
  },
  ActivityType: {
    AbsoluteIndependent: 'Đơn vị hành chính được giao tự chủ kinh phí',
    NoFinancialAutonomy: 'Đơn vị hành chính không được giao tự chủ kinh phí',
    RelativeIndependent: 'Đơn vị SNCL tự chủ một phần chi thường xuyên',
    Depedent: 'Đơn vị SNCL do NSNN cấp kinh phí',
    NormalExpenditureAndInvest: 'Đơn vị SNCL tự chủ chi thường xuyên và đầu tư',
    NormalExpenditure: 'Đơn vị SNCL tự chủ chi thường xuyên',
  },
  Particular: {
    General: 'Không chọn',
    Science: 'Bộ khoa học',
    Statistic: 'Tổng cục thống kê',
    VAAC_US_CDC: 'VAAC-US.CDC',
    NamDinh: 'Nam Định',
    DongNai: 'Đồng Nai',
    CompleteAutonomy: 'các đơn vị tự chủ hoàn toàn',
    SYTBacNinh: 'Sở y tế Bắc Ninh',
    BoLDTB_XH: 'Bộ Lao động - Thương binh và xã hội',
    DangAudit: 'Kế toán Đảng',
    StateAudit: 'Kiểm toán Nhà nước',
    SGDHaiDuong: 'Sở giáo dục Hải Dương',
    STCLongAn: 'Sở tài chính Long An',
    BoTTTT: 'Bộ Thông tin truyền thông',
    STCKhanhHoa: 'Sở tài chính Khánh Hòa',
  },
  PayerFee: {
    Organization: 'Đơn vị', //đơn vị
    Person: 'Người hưởng', //người hưởng
  },
  TaxRateDirectMethod: {
    ZeroPercent: '0%',
    OnePercent: '1%',
    TwoPercent: '2%',
    ThreePercent: '3%',
    FivePercent: '5%',
  },
  TaxRate: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  CODTax: {
    FivePercent: 'Khoản thu hộ chịu thuế GTGT 5%',
    TenPercent: 'Khoản thu hộ chịu thuế GTGT 10%',
  },
  TaxRateInventory: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  TaxRateFull: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    OnePercent: '1%',
    TwoPercent: '2%',
    ThreePercent: '3%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  TaxStatusNQ43: {
    Undentify: 'Chưa xác định',
    DecreasingTaxRate: 'Có giảm thuế',
    NoneDecreasingTaxRate: 'Không giảm thuế',
  },
  InvType: {
    // Loại Hóa đơn
    NoInvoice: 'Không có hóa đơn',
    NormalInvoice: 'Hóa đơn thông thường',
    InvoiceGTGT: 'Hóa đơn GTGT',
  },
  GovSource: {
    General: 'Không chọn',
    DomesticExpenditure: 'Nguồn chi từ vốn trong nước',
    ForeignExpenditure: 'Nguồn chi từ vốn ngoài nước',
  },
  BudgetItemType: {
    Group: 'Nhóm',
    SubGroup: 'Tiểu nhóm',
    Item: 'Mục',
    SubItem: 'Tiểu mục',
    SubSection: 'Tiết tiểu mục',
  },
  AccountTransferBusinessType: {
    BalanceTransferYear: 'Kết chuyển số dư cuối năm',
    PerformanceResultDefined: 'Xác định kết quả hoạt động',
  },
  ProjectType: {
    IntermAccountingUnitSt: 'Đơn vị kế toán trung gian 1',
    IntermAccountingUnitNd: 'Đơn vị kế toán trung gian 2',
    EstimatedUnitsSt: 'Đơn vị dự toán cấp 1',
    OutEstimatedUnitsStInProv: 'Ngoài đơn vị dự toán cấp 1 - trong cùng 1 tỉnh',
    OutEstimatedUnitsStDiffProv:
      'Ngoài đơn vị dự toán cấp 1 (khác tỉnh, khác Bộ, ngành) - trong lĩnh vực kế toán nhà nước',
    OutGovernmArea: 'Ngoài khu vực nhà nước',
  },
  AccountTransferTransferSide: {
    InDebt: 'Nợ',
    Yes: 'Có',
    BothSides: 'Hai bên',
  },
  ExecuteAction: {
    NoAction: 'Không xử lý',
    Inward: 'Nhập kho',
    Outward: 'Xuất kho',
  },

  SourceName: {
    Domestic: 'Nguồn ngân sách trong nước',
    Aid: 'Nguồn viện trợ',
    ForeignDebt: 'Nguồn vay nợ nước ngoài',
    FeeLeave: 'Nguồn phí được khấu trừ, để lại',
    OtherLeave: 'Nguồn hoạt động khác được để lại',
  },
  SourcePropertyNameB03: {
    RegularFund: 'Kinh phí thường xuyên/tự chủ',
    IrregularFund: 'Kinh phí không thường xuyên/không tự chủ',
  },
  SurplusTypeName: {
    STN001: 'Dư dự toán',
    STN002: 'Dư cam kết chi',
    STN003: 'Dư tạm ứng',
  },
  ReasonDecreaseFinalSettlement: {
    SubmitedStateBudget: 'Đã nộp NSNN',
    ToPayStateBudget: 'Còn phải nộp NSNN',
    CancelEstimate: 'Dự toán bị hủy',
  },
  OutwardPurpose: {
    OutwardUsed: 'Xuất dùng',
    OutwardSale: 'Xuất bán',
    OutwardOther: 'Xuất khác',
  },
  InOutwardPurpose: {
    OutwardUsed: 'Xuất dùng',
    OutwardOther: 'Xuất khác',
  },
  BudgetSourceKindType: {
    ActivityFund: 'Kinh phí hoạt động',
    RegularFund: 'Kinh phí thường xuyên',
    IrregularFund: 'Kinh phí không thường xuyên',
    ProjectFund: 'Kinh phí dự án',
    OrderPublicFund: 'Kinh phí theo đơn đặt hàng nhà nước',
    BasicConstructFund: 'Kinh phí đầu tư xây dựng cơ bản',
    InvestmentFund: 'Kinh phí tổng điều tra',
    PriorityFund: 'Kinh phí ưu đãi người có công',
    NotReturnFund: 'Kinh phí viện trợ không hoàn lại',
    DebtForeignFund: 'Kinh phí vay nợ nước ngoài',
  },
  BudgetSourceKindN01a: {
    RegularFund: 'Kinh phí thường xuyên',
    IrregularFund: 'Kinh phí không thường xuyên',
    BasicConstructFund: 'Kinh phí đầu tư xây dựng cơ bản',
    NotReturnFund: 'Kinh phí viện trợ không hoàn lại',
    DebtForeignFund: 'Kinh phí vay nợ nước ngoài',
  },

  BudgetFeesType: {
    Fee: 'Phí',
    Fees: 'Lệ phí',
  },
  InvoiceFormNumberType: {
    VatInvoice: 'Hóa đơn giá trị gia tăng',
    Bill: 'Hóa đơn bán hàng',
    DeliveryBillFreight: 'Phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ',
    DeliveryBillAgentSales: 'Phiếu xuất kho gửi bán hàng đại lý',
    ExportBill: 'Hóa đơn xuất khẩu',
    BillOfSale: 'Hóa đơn bán hàng (dành cho tổ chức, cá nhân trong khu phi thuế quan)',
    ElecInvoicePublicProperty: 'Hóa đơn điện tử bán tài sản công',
    ElecInvoiceNationalReserves: 'Hóa đơn điện tử bán hàng dự trữ quốc gia',
    DiffBills: 'Hóa đơn khác (tem, vé, thẻ...)',
    Documents: 'Chứng từ như hóa đơn (PXK kiêm vận chuyển nội bộ, PXK hàng gửi bán đại lý)',
  },
  ReportPeriod: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  ReportPeriodSettlement: {
    Year: 'Cả năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
  },
  ReportPeriodCustom: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần đến hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng đến hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý đến hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm đến hiện tại',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    NextWeek: 'Tuần sau',
    Next4Week: 'Bốn tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  InvoiceForm: {
    SeftPrintInvoice: 'Hóa đơn tự in',
    OrderPrintInvoice: 'Hóa đơn đặt in',
    ElectronicInvoice: 'Hóa đơn điện tử',
  },
  /**
   * Loại hợp đồng
   */
  ContractType: {
    Purchase: 'Hợp đồng mua',
    Sale: 'Hợp đồng bán',
    General: 'Không chọn',
  },
  StateImplement: {
    Stage: 'Theo giai đoạn',
    Annualy: 'Hàng năm',
  },
  ObjectType: {
    Construction: 'Công trình',
    WorkItem: 'Hạng mục công trình',
  },
  TypeEstimate: {
    FirstOfYear: 'Đầu năm',
    Addition: 'Bổ sung',
  },
  ReportCre: {
    MonthDecember: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
  },
  AutoBusinessType: {
    Auto: 'Mặc định',
    SelfSetting: 'Tự thiết lập',
  },
  /**
   * Giai đoạn đầu tư
   */
  InvestmentPeriod: {
    PrepareInvest: 'Giai đoạn chuẩn bị đầu tư',
    PerformInvest: 'Giai đoạn thực hiện đầu tư',
    EndInvest: 'Giai đoạn kết thúc xây dựng, đưa dự án vào khai thác sử dụng',
    Costs: 'Chi phí Ban quản lý dự án',
  },
  /**
   * Hình thức sổ kế toán
   */
  AccountingForm: {
    // Summary: 'Tổng hợp',
    SharedDiary: 'Nhật ký chung',
    LedgerDiary: 'Nhật ký - sổ cái',
    LicenseRecord: 'Chứng từ ghi sổ',
  },
  /**
   * Kí hiệu tiền tệ
   */
  MoneySign: {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    Dola: '$',
    Eur: 'EUR',
    None: 'Không chọn',
  },
  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)',
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $',
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)',
    '-n$': '-n$',
    'n$-': 'n$-',
  },
  /**
   * Hệ thống tùy chỉnh ngầm định nghiệp vụ
   */
  DefaultConfigBusiness: {
    None: 'Không chọn',

    AdvanceDistributed: 'Tạm ứng đã cấp dự toán',

    AdvanceUndistributed: 'Tạm ứng chưa cấp dự toán',

    AdvancePayment: 'Thanh toán tạm ứng',

    Expense: 'Thực chi',

    PlanReceipt: 'Nhận dự toán',

    TreasuryWarrantReceipt: 'Nhận lệnh chi tạm ứng',

    ReceiptExpense: 'Ghi thu, ghi chi',

    TreasuryWarrantReceiptExpense: 'Nhận lệnh chi thực chi',

    ExpenseReduce: 'Giảm chi - Thực chi',

    ExpenseReduceAdvance: 'Giảm chi - Tạm ứng',

    RefundExpense: 'Nộp trả - Thực chi',

    RefundAdvance: 'Nộp trả - Tạm ứng',

    Supplement: 'Bổ sung',

    RestoreExpense: 'Nộp phục hồi - Thực chi',

    RestoreAdvance: 'Nộp phục hồi - Tạm ứng',

    BudgetRejecttion: 'Xuất toán',

    ReceiptBudgetReturn: 'Giảm thu',

    IncrementAdjustment: 'Điều chỉnh tăng thuế GTGT',

    DecrementAdjustment: 'Điều chỉnh giảm thuế GTGT',

    DestroyPlanning: 'Hủy dự toán',

    BUPlanAdjustment: 'Điều chỉnh dự toán',

    DestroyReceipt: 'Hủy lệnh chi tiền',

    ReceiptForInferior: 'Lệnh chi cấp cho cấp dưới',

    ReceivedReceiptFromSuperiors: 'Lệnh chi nhận từ cấp trên',
  },
  /**
   * Hình thức cấp phát
   */
  AllocationFormat: {
    Budget: 'Dự toán',

    TreasuryWarrant: 'Lệnh chi',

    InKind: 'Hiện vật',

    RecordReceiptExpense: 'Ghi thu - Ghi chi',

    Other: 'Khác',
  },
  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -',
  },
  /**
   * Font chữ
   */
  FontFamily: {
    TimesNewRoman: 'Times New Roman',
    OpenSan: 'Open Sans',
    Arial: 'Arial',
    Tahoma: 'Tahoma',
    Cambria: 'Cambria',
    ArialNarrow: 'Arial Narrow',
  },
  /**
   * Kiểu chữ
   */
  FontStyle: {
    Regular: 'Regular',
    Bold: 'Bold',
    Italic: 'Italic',
    BoldItalic: 'Bold Italic',
  },
  /**
   *Ghi chú - thiết lập quy tắc hạch toán đồng thời
   */
  SignType: {
    Record: 'Ghi âm',
    Positive: 'Ghi dương',
  },
  /**
   * Công thức âm dương
   */
  SignFormula: {
    Negative: '-',
    Positive: '+',
  },
  /**
   * Tính chất nguồn
   */
  BudgetSourceGroupPropertyType: {
    NotSelected: 'Không chọn',
    Regular: 'Thường xuyên',
    IRegular: 'Không thường xuyên',
  },
  /**
   * Tỉnh/thành phố
   */
  Province: {
    HaNoi: 'Hà Nội',
    HoChiMinh: 'Hồ Chí Minh',
    DaNang: 'Đà Nẵng',
    CanTho: 'Cần Thơ',
  },
  /**
   * vị trí dòng group in báo cáo
   */
  SummaryRowPosition: {
    Top: 'Hiển thị tên nhóm và tổng cộng ở trên',
    Bottom: 'Hiển thị tên nhóm và tổng cộng ở dưới',
    Both: 'Hiển thị tên nhóm ở trên và tổng cộng ở dưới',
  },
  /**
   * Xuất gửi cho
   */
  ExportFor: {
    SendTreasury: 'Xuất khẩu gửi kho bạc nhà nước',
    SendTaxAuthorities: 'Xuất khẩu gửi cơ quan thuế',
  },

  ReportID: {
    // Báo cáo tài chính
    BCTC01: 'BCTC-01',
    BCTC02: 'BCTC-02',
    BCTC03b: 'BCTC-03b',
    BCTC03a: 'BCTC-03a',
    BCTC04: 'BCTC-04',
    BCTC05: 'BCTC-05',
    BCTCExport04: 'BCTCExport-04',
    BCTC01bstt: 'BCTC-01bstt',

    // Báo cáo quyết toán
    BCQT02: 'BCQT-02',
    BCQT03: 'BCQT-03',
    BCQT03TCTK: 'BCQT-TCTK-03',
    BCQT03_BTTTT: 'BCQT-03-BTTT',
    BudgetSourceUsing_BTTTT: 'BudgetSourceUsing_BTTTT',
    // Báo cáo thực hiện xử lý kiến nghị của kiểm toán, thanh tra, tài chính
    B02_BCQT: 'B02_BCQT',

    // Báo cáo chứng từ
    DNTTV04a: 'DNTTV04a',
    FixedAssetTag: 'FixedAssetTag',

    // Báo cáo kho bạc
    S104H: 'S104H',
    //Sổ chi tiết theo dõi số liệu quyết toán
    S105H1: 'S105H1',

    //Sổ chi tiết theo dõi số liệu quyết toán
    S106H1: 'S106H1',

    // Báo cáo S105-H Phần 2: Sổ theo dõi nguồn phí khấu trừ, được để lại (Phần II)
    S105_H_2: 'S105H2',

    // Báo cáo S106-H Phần 2: Sổ theo dõi nguồn thu hoạt động khác để lại (Phần II)
    S106_H_2: 'S106H2',

    S13H: 'S13H',
    // Sổ đăng ký chứng từ ghi sổ
    S02bH: 'S02b-H',
    S101H1: 'S101H1',

    // Báo cáo vật tư hàng hóa
    S21H: 'S21-H',
    S22H: 'S22-H',
    S23H: 'S23-H',

    // Báo cáo tồn kho
    InventoryBookMaster: 'InventoryBookMaster',
    InventoryBook_ToAmount: 'InventoryBook_ToAmount',
    //  báo cáo Sổ chi tiết bán hàng
    SaleDetail: 'SaleDetail',
    // Phiếu điều chỉnh số liệu ngân sách (Thông tư số 19/2020/TT-BTC)
    BCC210NSTT19: '652_C2_10NS_TT19',

    // Báo cáo đồi chiếu kho bạc
    CashInBankConfirmation: 'CashInBankConfirmation',
    S12H: 'S12-H',
    S11H: 'S11-H-Report',
    B02_TT90_2018: 'B02_TT90_2018',
    // Báo cáo sổ chi tiết mua hàng
    PurchaseDetailBook: 'PurchaseDetailBook',
    // mẫu S02c-H: Sổ cái - Hình thức chứng từ ghi sổ (PBI 59376)
    S02C_H: 'S02c-H',
    B01_BCQT: '01_BCQT',
    B01_BCQT_KTNN: '01_BCQT_KTNN',
    B04_BCQT_KTNN: 'B04_BCQT_KTNN',
    // Mẫu Sổ cái - Mục lục ngân sách
    S03_H_Budget: 'S03-H-Budget',
    //Phụ biểu F01-01/BCQT: Báo cáo chi tiết chi từ nguồn NSNN và nguồn phí được khấu trừ, để lại
    B01_01_BCQT_Master: '01_01_BCQT_Master',
    B01_01_BCQT: '01_01_BCQT',
    // Báo cáo Sổ tổng hợp tài khoản
    GLSummaryAccount: 'GLSummaryAccount',

    //Phụ biểu F01-02/BCQT: Báo cáo chi tiết kinh phí chương trình, dự án
    F01_02_BCQT_P2: 'F01_02_BCQT',
    F01_02_BCQTP1: 'F01_02_BCQT_P1', // phần 1 của bc F01_02
    F01_02_BCQTP2: 'F01_02_BCQT_P2', // phần 2 của bc F01_02

    //Thuyết minh B01/BSTT báo cáo bổ sung thông tin tài chính
    B01_BSTT_TM: 'B01_BSTT_TM',

    //S04-H: Sổ nhật ký chung
    S04_H: 'S04-H',
    //bqdiep 07/12/2022: cập nhật thêm báo cáo S34-H; S34-H: Sổ chi tiết thanh toán với khách hàng
    S34_H: 'S34-H',
    // Báo cáo S101-H Phần 2: Sổ tổng hợp theo dõi dự toán từ nguồn NSNN trong nước
    S101_H_2: 'S101H2',
    // Báo cáo S02a-H: Chứng từ ghi sổ
    S02a_H: 'S02a-H',

    // Báo cáo Đối chiếu kho bạc
    N01a_SDKP_DVDT: 'N01a_SDKP_DVDT',
    N01b_SDKP_DVDT: 'N01b_SDKP_DVDT',
    N02a_SDKP_DVDT: 'N02a_SDKP_DVDT',
    N02b_SDKP_DVDT: 'N02b_SDKP_DVDT',

    N01a_SDKP_DVDT_ND112020: 'N01a_SDKP_DVDT_ND112020',
    N01b_SDKP_DVDT_ND112020: 'N01b_SDKP_DVDT_ND112020',
    N02a_SDKP_DVDT_ND112020: 'N02a_SDKP_DVDT_ND112020',
    N02b_SDKP_DVDT_ND112020: 'N02b_SDKP_DVDT_ND112020',
    //Sổ nhật ký mua hàng
    PurchaseDiary: 'PurchaseDiary',
    // S62-H: Sổ chi phí sản xuất, kinh doanh (Hoặc đầu tư XDCB)
    S62_H: 'S62-H',

    //Sổ chi tiết công nợ phải thu
    LiabilityObjectMonitor: 'LiabilityObjectMonitor',
    //báo cáo tổng hợp công nợ phải thu
    SummaryReceivable: 'SummaryReceivable',

    // InventoryInStockByBatch : Báo cáo tồn kho theo lô
    InventoryInStockByBatch: 'InventoryInStockByBatch',
    // Báo cáo tồn kho theo theo chứng từ nhập
    InventoryInStockByInward: 'InventoryInStockByInward',
    // Báo cáo tổng hợp công nợ
    SummaryOther: 'SummaryOther',
    // Báo cáo Số theo dõi tạm ứng
    AdvanceTracking: 'AdvanceTracking',
    // Báo cáo Sổ cái tài khoản nhóm theo đối ứng
    GeneralLedgerCorresponding: 'GeneralLedgerCorresponding',
    // Báo số dư các chi tiết của 1 tài khoản
    AccountDetailBalance: 'AccountDetailBalance',
    //Báo cáo đối chiếu hạch toán tài chính và hạch toán ngoài bảng
    ComparisonReportParalell: 'ComparisonReportParalell',
    // Báo số tổng hợp tình hình kinh phí dự án
    SummaryProjectExpense: 'SummaryProjectExpense',
    S24H: 'S24H',
    //Báo cáo đối chiếu kinh phí rút và chi theo MLNS
    F02_01H_QD19: 'F02_01H_QD19',
    // S52-H: Sổ chi tiết các khoản tạm thu
    S52H: 'S52H',
    // SummaryPayable : Tổng hợp công nợ phải trả
    SummaryPayable: 'SummaryPayable',
    // Biểu số 58 - Phụ lục tổng hợp đối chiếu tại KBNN nơi giao dịch
    ReportParam_B58_KTNNNew: 'ReportParam_B58_KTNNNew',

    ReportSaleVoucherCompare: 'ReportSaleVoucherCompare',
    MinutesInventoryFixedAsset: 'MinutesInventoryFixedAsset',

    // C55-HD: Bảng tính hao mòn tài sản
    AttritionCaculateBook: 'AttritionCaculateBook',
    // Báo cáo Mấu số 07 - Phiếu xuất kho
    42_11: '42.11',
    42_11_214: '42.11_214',
    42_11_212: '42.11_212',
    // Báo cáo Quyết toán tổng hợp nhập xuất tồn
    GeneralImportExportReserveSettlement: 'GeneralImportExportReserveSettlement',
    // Báo cáo Vật tư hàng hóa tồn kho đầu năm
    InventoryItemBeginYearOpenning: 'InventoryItemBeginYearOpenning',

    // S26-H: Sổ theo dõi công cụ, dụng cụ tại nơi sử dụng
    S26H: 'S26HSupply',

    // Báo cáo kiểm kê tài sản cố định
    InventoryFixedAsset: 'InventoryFixedAsset',

    // Báo cáo tăng giảm tài sản cố định
    UpDownFixedAsset: 'B04-H-01',
    // S05H: Bảng cân đối phát sinh các tài khoản
    S05H: 'S05H',

    // Báo cáo kiểm kê TSCĐ mẫu phòng ban
    InventoryFixedAsset_Department: 'InventoryFixedAsset_Department',

    // Biểu số 3: Công khai thực hiện dự toán thu - chi ngân sách (Thông tư 90/2018/TT-BTC)
    B03_TT90_2018_KTNN: 'B03_TT90_2018_KTNN',
    InventoryFixedAsset_Department: 'InventoryFixedAsset_Department',
    // [BC] Báo cáo chênh lệch thu, chi theo hoạt động SXKD, dịch vụ
    DifferenceReceiptExpenseByActivity: 'DifferenceReceiptExpenseByActivity',
    // VoucherListByStatisticsCode: Liệt kê chứng từ kế toán theo mã thống kê
    VoucherListByStatisticsCode: 'VoucherListByStatisticsCode',
    // VoucherByTypeDiary: Sổ theo dõi Chuyển khoản
    VoucherByTypeDiary: 'VoucherByTypeDiary',
    // Báo cáo chi tiết kinh phí hoạt động đặc thù sở giáo dục hải dương
    BudgetActivitySGDHD: 'BudgetActivitySGDHD',
    // B58_KTNN: Phụ lục tổng hợp đối chiếu tại KBNN
    B58_KTNN: 'B58_KTNN',
    // BC F01_01/BCTC đặc thù hải dương
    F0101BCQTHD: '01_01_BCQT_HD',
    // Bảng in tổng hợp của tài khoản
    SummaryByAccount: 'SummaryByAccount',

    // Sổ chi tiết vật tư hàng hóa theo chứng từ nhập (PP đích danh)
    InwardOutwardDetailByVoucher: 'InwardOutwardDetailByVoucher',

    // Báo cáo C03-CCTT
    C03_CCTT: 'C03/CCTT',

    // biểu 04 thông tư 90 2018
    B04_TT90_2018: 'B04_TT90_2018',

    // Báo cáo tình hình thu phí, lệ phí
    MA1_BCQT: 'MA1_BCQT',
    // Báo cáo biểu số 59 đặc thù KTNN
    ReportParam_TT3422016_B59_KTNN: 'ReportParam_TT3422016_B59_KTNN',
    // Báo cáo Thống kê xuất kho theo đơn vị sử dụng tại đơn vị
    OutwardStockStatisticByDepartment: 'OutwardStockStatisticByDepartment',
    //Báo cáo F0101 KTNN
    F01_01_BCQT_KTNN: '01_01_BCQT_KTNN',
    //Báo cáo B59 KTNN
    B59_KTNN: 'B59_KTNN',
    // biểu 04 thông tư 90 2018 KTNN
    B04_TT90_2018_KTNN: 'B04_TT90_2018_KTNN',
    S53_H: 'S53-H', // Sổ theo dõi thuế GTGT
    // Sổ theo dõi chi tiết tình hình thực hiện kinh phí đề tài
    VHL_DetailProject: 'VHL_DetailProject',
    // Báo cáo biểu số 59 đặc thù KTNN
    ReportParam_BudgetSourceUsing_BTTTT: 'ReportParam_BudgetSourceUsing_BTTTT',
    // Báo cáo Tình hình sử dụng dự toán chi thường xuyên NSTW (cấp tỉnh/cấp huyện/cấp xã) theo hình thức rút dự toán, niên độ…
    B05_BTTTT: 'B05_BTTTT',
    // Báo cáo danh sách chứng từ chưa sinh hạch toán đồng thời
    VoucherNoParalell: 'VoucherNoParalell',
    // Đối chiếu chứng từ mua hàng và chứng từ thanh toán
    ComparePUInvoiceAndPayment: 'ComparePUInvoiceAndPayment',
    // mẫu B03_BCQT: [BC] B03/BCQT: Thuyết minh báo cáo quyết toán đặc thù BTTTT
    BCQT_03_BTTTT: 'BCQT-03-BTTT',
    // Sổ chi tiết công nợ phải trả theo ngoại tệ
    PayableDetailByCurrency: 'PayableDetailByCurrency',
    // Sổ chi tiết công nợ phải thu theo ngoại tệ
    ReceiptableDetailByCurrency: 'ReceiptableDetailByCurrency',

    C2_10NS_RealExpenseAdjustment_TT19_Detail: 'C2_10NS_RealExpenseAdjustment_TT19_Detail',

    C2_10NS_RealExpenseAdjustment_TT19: 'C2_10NS_RealExpenseAdjustment_TT19',

    // Tổng công nợ phải trả theo ngoại tệ
    SummaryPayableByCurrency: 'SummaryPayableByCurrency',
    // C23-HD: Biên bản kiểm kê vật tư, công cụ, sản phẩm, hàng hóa
    C23HD: 'C23HD',
    // Thống kê chứng từ kế toán
    AccountingVoucherList: 'AccountingVoucherList',

    // mẫu s24H chi tiết nguồn
    S24H_DetailSource: 'S24H_DetailSource',
  },
  /**
   * Loại công thức
   */
  ColumnDataType: {
    //Hệ số
    Coefficient: 'Hệ số',
    //Tỷ lệ
    Rate: 'Tỷ lệ',
    //Khác
    Other: 'Khác',
  },
  /**
   * Loại Nộp kinh phí
   */
  UnionInsurance: {
    //Bảo hiểm
    Insurance: 'Bảo hiểm',
    //KPCĐ
    LaborUnion: 'Kinh phí công đoàn',
    GroupUnion: 'Đoàn phí công đoàn',
  },

  /**
   * Tính số nộp kỳ này
   */
  CalculatePay: {
    //Bảo hiểm
    All: 'Trên toàn bộ số phát sinh',
    //KPCĐ
    ExcludeInsurance: 'Sau khi trừ bảo hiểm trả thay lương',
  },

  /**
   *Loại khoản lương
   */
  PayrollItemType: {
    //Thu nhập thường xuyên
    IncomRecurrent: 'Thu nhập thường xuyên',
    //Thu nhập không thường xuyên
    IncomCasual: 'Thu nhập không thường xuyên',
    //Khấu trừ thường xuyên
    OutcomRecurrent: 'Khấu trừ thường xuyên',
    //Khấu trừ không thường xuyên
    OutcomCasual: 'Khấu trừ không thường xuyên',
  },

  /**
   *Loại khoản lương
   */
  PayrollItemColumnType: {
    //Thu nhập thường xuyên
    IncomRecurrent: 'Thu nhập thường xuyên',
    //Thu nhập không thường xuyên
    IncomCasual: 'Thu nhập không thường xuyên',
    //Khấu trừ thường xuyên
    OutcomRecurrent: 'Khấu trừ thường xuyên',
    //Khấu trừ không thường xuyên
    OutcomCasual: 'Khấu trừ không thường xuyên',
    Timekeeping: 'Chấm công',
    SalaryRule: 'Quy định lương, thuế, báo hiểm',
  },

  /**
   * Hình thức hóa đơn
   */
  PayForm: {
    Cash: 'TM', // Tiền mặt
    Transfer: 'CK', // Chuyển khoản
    Undefined: 'TM/CK', // Chưa xác định được hình thức thanh toán
  },

  /**
   * Mã lỗi Validate
   */
  ValidateCode: {
    Required: 'Nhập thiếu thông tin',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác',
    Duplicate: 'Dữ liệu đã tồn tại trong hệ thống',
    Arise: 'Danh mục đã có phát sinh',
    System: 'Dữ liệu thuộc hệ thống',
    StartWithOther: 'Phần đầu trùng với số hiệu của cài khoản con cùng cấp',
    ExistDictionary: 'Thông tin không tồn tại',
  },

  MessageBoxType: {
    confirm_Info_Warning: 0,
    confirm_Yes_No: 1,
    confirm_Yes_No_Cancel: 2,
    confirm_Delete: 3,
    confirm_Close: 4,
  },

  /**
   * RefType danh mục
   * bnanh 04.07.2022
   */
  RefTypeDictionary: {
    CustomerVendor: 1, // Khách hàng, nhà cung cấp
    Employee: 2, // Cán bộ
  },

  /**
   * Enum Ngừng theo dõi
   * NVTUAN1 07.07.2022
   */
  Inactive: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum Dùng công thức
   */
  UseFormula: {
    Use: 'Có công thức',
    None: 'Không có công thức',
  },

  /**
   * Enum xử lý ở điều chỉnh tồn kho
   * NVTOAN2 09/07/2022
   */
  Execute: {
    All: 'Tất cả',
    Excuted: 'Đã xử lý',
    NotExcute: 'Chưa xử lý',
  },

  /**
   * Enum Ngừng theo dõi
   * NVTOAN2 09/07/2022
   */
  TreasuryApprove: {
    All: 'Tất cả',
    Paid: 'Đã thanh toán',
    UnPaid: 'Chưa thanh toán',
  },

  /**
   * Enum Theo dõi
   * tvhien 01.08.2022
   */
  Active: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum Đã lập hồ sơ
   * nmtuan4 26.4.2023
   */
  IsDvcVoucher: {
    All: 'Tất cả',
    Created: 'Đã lập hồ sơ',
    NotCreated: 'Chưa lập hồ sơ',
  },

  /**
   * Enum Đã sinh chứng từ
   * lttuan1 26.4.2023
   */
  IsPlanned: {
    All: 'Tất cả',
    Planned: 'Đã sinh chứng từ',
    NotPlanned: 'Chưa sinh chứng từ',
  },

  /**
   * Enum ghi sổ
   * HQMINH 12.07.2022
   */
  PostedType: {
    All: 'Tất cả',
    NotPosted: 'Chưa ghi sổ',
    Posted: 'Ghi sổ',
  },

  /**
   * Enum Tính thuế
   * TVDAT 12.07.2022
   */
  IsPersonalIncomeTax: {
    All: 'Tất cả',
    IsPersonalIncomeTax: 'Tính thuế',
    NotIsPersonalIncomeTax: 'Không tính thuế',
  },
  /**
   * Enum Tính BHXH
   * TVDAT 12.07.2022
   */
  IsSocialInsurance: {
    All: 'Tất cả',
    IsSocialInsurance: 'Tính BHXH',
    NotIsSocialInsurance: 'Không tính BHXH',
  },
  /**
   * Enum Tính BHYT
   * TVDAT 12.07.2022
   */
  IsHealthInsurance: {
    All: 'Tất cả',
    IsHealthInsurance: 'Tính BHYT',
    NotIsHealthInsurance: 'Không tính BHYT',
  },
  /**
   * Enum Tính BHTN
   * TVDAT 12.07.2022
   */
  IsUnemploymentInsurance: {
    All: 'Tất cả',
    IsUnemploymentInsurance: 'Tính BHTN',
    NotIsUnemploymentInsurance: 'Không tính BHTN',
  },
  /**
   * Enum Tính KPCĐ
   * TVDAT 12.07.2022
   */
  IsLaborUnion: {
    All: 'Tất cả',
    IsLaborUnion: 'Tính KPCĐ',
    NotIsLaborUnion: 'Không tính KPCĐ',
  },
  /**
   * Group ref type
   * NCPHUOC 12/07/2022
   */
  RefTypeGroup: {
    BUPlanReceipt: 'Nhận dự toán',
    BUTransfer: 'Chuyển khoản kho bạc',
  },

  /**
   * Trạng thái validate của dòng nhập khẩu
   * NCPHUOC 28/07/2022
   */
  ImportValidateStatus: {
    Valid: 'Hợp lệ',
    DataExist: 'Dữ liệu đã tồn tại',
    NotValid: 'Không hợp lệ',
  },

  /**
   * CTMT, DA
   * @author nnnam - 3/8/2022
   */
  ProjectObjectType: {
    Target: 'Chương trình mục tiêu',
    Project: 'Dự án',
  },
  /* Enum đã lập hóa đơn
   * HQMINH 02.08.2022
   */
  Invoiced: {
    All: 'Tất cả',
    NotInvoiced: 'Chưa lập hóa đơn',
    Invoiced: 'Đã lập hóa đơn',
  },

  /**
   * Enum thu nhập không thường xuyên
   * vqphong - 15/12/2022
   */
  OtherIncome: {
    All: 'Tất cả',
    PayWithSalary: 'Có trả cùng lương',
    NotPayWithSalary: 'Không trả cùng lương',
  },

  /**
   * Enum khấu trừ không thường xuyên
   * vqphong - 15/12/2022
   */
  OtherOutcome: {
    All: 'Tất cả',
    PayWithSalary: 'Có trừ vào lương',
    NotPayWithSalary: 'Không trừ vào lương',
  },

  /**
   * Enum Phương pháp tính giá
   * NVTUAN1 12.08.2022
   */
  CostMethod: {
    //Bình quân cuối kỳ
    ClossingAverage: 0,
    //Bình quân tức thì
    ImmediateAverage: 1,
    //Đích danh
    RealName: 2,
    //Nhập trước xuất trước
    FirstInFirstOut: 3,
  },

  /**
   * Enum mẫu báo cáo
   * dqdat1 16.08.2022
   */
  ReportParamType: {
    ND11_2020: 'Nghị định 11/2020/NĐ-CP',
    DongThap: 'Đặc thù Đồng Tháp',
  },

  ReportParamTypeBudgetItem: {
    F01_01_BCQT: 'Mẫu thông tư số 107/2017/TT-BTC',
    F01_01_BCQT_BudgetItemDetail: 'Mẫu tiết tiểu mục',
  },

  ReportParamTypeF0101BCQT: {
    F01_01_BCQT: 'Mẫu thông tư số 107/2017/TT-BTC',
  },

  ReportParamTypeN01aSDKPDVDTND112020: {
    N01a_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
    N01a_SDKP_DVDT_ND112020_Dynamic: 'Nghị định 11/2020/NĐ-CP (Mẫu tùy chỉnh)',
  },

  ReportParamTypeN01bSDKPDVDTND112020: {
    N01b_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
  },

  ReportParamTypeN02aSDKPDVDTND112020: {
    N02a_SDKP_DVDT_ND112020_Update: 'Thông tư 18/2020/TT-BTC',
    N02a_SDKP_DVDT_ND112020_UpdateDynamic: 'Thông tư 18/2020/TT-BTC (Mẫu tùy chỉnh)',
    N02a_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
    N02a_SDKP_DVDT_Dynamic_ND112020: 'Nghị định 11/2020/NĐ-CP (Mẫu tùy chỉnh)',
  },

  ReportParamTypeN02bSDKPDVDTND112020: {
    N02b_SDKP_DVDT_ND112020: 'Nghị định 11/2020/NĐ-CP',
  },

  ReportParamTypeS22H: {
    S22_H_QD19: 'Thông tư 107/2017/TT-BTC',
  },

  ReportParamTypeCDTB03: {
    A4_Vertical: 'Mẫu A4 dọc',
    A4_Horizontal: 'Mẫu A4 ngang',
  },

  ReportParamTypeCDTF03C: {
    A4_Vertical: 'Mẫu A4 dọc',
    A4_Horizontal: 'Mẫu A4 ngang',
  },

  /**
   * Enum Nghiệp vụ trong form in chứng từ mẫu 05/TT
   * TTLONG 11/08/2022
   */
  Major: {
    Expense: 'Thực chi',
    Advance: 'Tạm ứng',
    AdvanceIsNotEligibleForPayment: 'Ứng trước chưa đủ điều kiện thanh toán',
    AdvanceIsEligibleForPayment: 'Ứng trước đủ điều kiện thanh toán',
    None: 'Không chọn',
  },
  /**
   * Enum Hình thức thanh toán trong form in chứng từ mẫu 05/TT
   * TTLONG 11/08/2022
   */
  PaymentFormality: {
    Transfer: 'Chuyển khoản',
    CashAtKB: 'Tiền mặt tại KB',
    CashAtNH: 'Tiền mặt tại NH',
    None: 'Không chọn',
  },

  PaymentFormality_Tooltip: {
    Transfer: 'Chuyển khoản',
    CashAtKB: 'Tiền mặt tại kho bạc',
    CashAtNH: 'Tiền mặt tại ngân hàng',
    None: 'Không chọn',
  },

  /** enum mẫu báo cáo S11H - Sổ kế toán tiền mặt*/
  S11HReportType: {
    defaultType: 'Mẫu quản trị',
    TT107: 'Mẫu thông tư số 107/2017/TT-BTC',
    MXP: 'Mẫu xã, phường',
  },
  /*
   * Enum nghiệp vụ báo cáo
   */
  ReportCashWithDrawType: {
    PaymentAdvance: 'Tạm ứng sang thực chi',
    EstimateAdvance: 'Ứng trước chưa đủ ĐKTT sang Ứng trước đủ ĐKTT',
    NotSelected: 'Không chọn',
  },
  /**
   * Enum kinh phí tạm ứng để thanh toán tạm ứng
   */
  ReportBudgetSourceKindType: {
    RegularFund: 'Kinh phí đã cấp dự toán hoạt động thường xuyên',
    IrregularFund: 'Kinh phí đã cấp dự toán hoạt động không thường xuyên',
    ProjectFund: 'Kinh phí đầu tư XDCB',
  },
  /**
   * Enum mẫu báo cáo S21-H: Sổ kho
   * NCQUYEN 16/08/2022
   */
  S21HReportType: {
    TT107: 'Thông tư 107/2017/TT-BTC',
    CompositeSample: 'Mẫu tổng hợp',
  },

  InventoryBookMasterReportType: {
    InventoryBookMaster: 'Mẫu báo cáo tồn kho',
    InventoryBookMasterAverage: 'Mẫu hiển thị đơn giá nhập bình quân',
  },

  /**
   * Enum mẫu báo cáo S61-H: Sổ chi tiết chi phí
   * lttuan1 10/10/2022
   */
  S61HReportType: {
    TT107: 'Mẫu theo Thông tư 107/2017/TT-BTC',
    TM: 'Mẫu chi tiết theo tiểu mục',
    TTM: 'Mẫu chi tiết theo tiết tiểu mục',
  },

  /**
   * S04- H: Sổ nhật ký chung
   */
  S04HReportType: {
    TT107: 'Thông tư 107/2017/TT-BTC',
    AO: 'Chi tiết theo đối tượng',
  },

  /**
   * Enum mẫu Báo cáo tình hình tăng giảm CCDC
   * lttuan1 09.12.2022
   */
  SupplyIncreaseDecreaseReportType: {
    Detail: 'Mẫu in chi tiết',
    Summary: 'Mẫu in tổng hợp',
  },

  /**
   * Enum mẫu báo cáo S01-H: Sổ chi tiết chi phí
   * lttuan1 10/10/2022
   */
  S01HReportType: {
    A4: 'Mẫu thông tư 107/2017/TT-BTC - Khổ A4',
    A3: 'Mẫu thông tư 107/2017/TT-BTC - Khổ A3',
  },

  /**
   * Mã check tk có bắt đầu bằng 111 thì cho phép in chứng từ
   * TPNAM 28.08.2022
   */
  C4HDTCType: {
    StartWidth111: '111',
  },
  /**
   * Đơn vị tính
   * pt hai 31/08/2022
   */
  UnitMoney: {
    One: 'Đồng',
    OneThousand: 'Nghìn đồng',
    OneMillion: 'Triệu đồng',
    OneBillion: 'Tỷ đồng',
  },

  DashboardUnitMoney: {
    Basic: 'Đồng',
    OneThousand: 'Nghìn đồng',
    Million: 'Triệu đồng',
    OneBillion: 'Tỷ đồng',
  },

  /**
   * Trạng thái hóa đơn
   * tvhien 31.08.2022
   */
  SaleInvoiceStateType: {
    SaleInvoice: 'HĐ mới',
    SaleInvoiceReplace: 'HĐ thay thế',
    SaleInvoiceAdjustment: 'HĐ điều chỉnh',
    SaleInvoiceCancel: 'HĐ đã bị hủy',
    SaleInvoiceReplaced: 'HĐ đã bị thay thế',
    SaleInvoiceAdjustmented: 'HĐ đã bị điều chỉnh',
  },

  /**
   * Trạng thái phát hành khi không có mã cơ quan thuế
   * tvhien 31.08.2022
   */
  SaleInvoiceStateReleaseType: {
    UnRelease: 'Chưa phát hành',
    IsReleased: 'Đang phát hành',
    Released: 'Đã phát hành',
    ReleaseError: 'Phát hành lỗi',
    NoSendTax: 'Chưa gửi cho CQT',
    SendTax: 'Đã gửi cho CQT',
    SaleInvoiceInValid: 'HĐ không hợp lệ',
    SaleInvoiceValid: 'HĐ hợp lệ',
  },

  /**
   * Trạng thái phát hành khi có mã cơ quan thuế
   * tvhien 16.09.2022
   */
  SaleInvoiceStateCQT: {
    UnRelease: 'Chưa phát hành',
    IsReleased: 'Đang phát hành',
    ReleaseError: 'Phát hành lỗi',
    NoSendTax: 'Chờ cấp mã',
    SendTax: 'Đã cấp mã',
    SaleInvoiceInValid: 'HĐ không hợp lệ',
    Rejected: 'Từ chối cấp mã',
    Released: 'Đã phát hành', //DVMINH 02/01/2024 Bổ sung thêm trạng thái Đã phát hành
  },

  /**
   * Trạng thái gửi hóa đơn
   * tvhien 16.09.2022
   */
  SendInvoiceStatus: {
    NoSend: 'Chưa gửi',
    SendWaiting: 'Chờ gửi',
    Send: 'Đã gửi',
  },

  /**
   * Nghị định để load hóa đơn
   */
  SaleInvoiceType: {
    Decree123: 'Nghị định 123/2020/NĐ-CP',
    Decree51: 'Nghị định 51/2010/NĐ-CP',
  },

  FormulaSign: {
    add: '+',
    subtract: '-',
    multiple: 'x',
    divide: '/',
  },

  // loại icon hiển thị tại msCellInput
  SuffixIconType: {
    More: 0,
    View: 1,
    Edit: 2,
  },

  ReportS05: {
    S05: 'Thông tư 107/2017/TT-BTC',
    S05_2Ben: 'Mẫu số dư hai bên',
  },

  /**Lũy kế phát sinh */
  AccumIncurred: {
    StartData: 'Ngày bắt đầu dữ liệu',
    StartYear: 'Ngày bắt đầu năm TC của kỳ báo cáo',
  },
  /**
   * đã hạch toán hay chưa
   */
  IsPosted: {
    All: 'Tất cả',
    UnPosted: 'Chưa hạch toán',
    Posted: 'Đã hạch toán',
  },

  /**
   * Đã ghi sổ hay chưa
   */
  IsPostedSearch: {
    UnPosted: 'Chưa ghi sổ',
    Posted: 'Đã ghi sổ',
  },

  IsTreasuryApproved: {
    NotApproved: 'Chưa duyệt',
    Approved: 'Đã duyệt',
  },

  SearchField: {
    ref_date: 'ref_date',
    ref_no: 'ref_no',
    ref_type: 'ref_type',
    posted_date: 'posted_date',
    inv_date: 'inv_date',
    inv_no: 'inv_no',
    debit_account: 'debit_account',
    credit_account: 'credit_account',
    amount: 'amount',
    budget_source_code: 'budget_source_code',
    budget_chapter_code: 'budget_chapter_code',
    budget_provide_code: 'budget_provide_code',
    budget_kind_item_code: 'budget_kind_item_code',
    budget_sub_kind_item_code: 'budget_sub_kind_item_code',
    method_distribute_type: 'method_distribute_type',
    budget_item_code: 'budget_item_code',
    budget_sub_item_code: 'budget_sub_item_code',
    accounting_object_code: 'accounting_object_code',
    inventory_item_code: 'inventory_item_code',
    inventory_item_tool_code: 'inventory_item_tool_code',
    quantity: 'quantity',
    stock_code: 'stock_code',
    description: 'description',
    activity_code: 'activity_code',
    cash_withdraw_type_id: 'cash_withdraw_type_id',
    fixed_asset_code: 'fixed_asset_code',
    project_code: 'project_code',
    fund_code: 'fund_code',
    department_code: 'department_code',
    statistic_code: 'statistic_code',
    is_treasury_approved: 'is_treasury_approved',
    approved_date: 'approved_date',
    debit_bank_account: 'debit_bank_account',
    credit_bank_account: 'credit_bank_account',
    bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
    budget_source_property_code: 'budget_source_property_code',
    budget_fees_code: 'budget_fees_code',
    contract_no: 'contract_no',
    contract_sell_no: 'contract_sell_no',
    topic_code: 'topic_code',
  },

  /**
   * Trạng thái hồ sơ đối chiếu trên KBNN
   */
  DCSDFileTreasuryStatus: {
    WaitKBNNStaff: 'Chờ GDV tiếp nhận hồ sơ',
    KBNNStaffReject: 'GDV từ chối tiếp nhận hồ sơ',
    KBNNStaffApprove: 'GDV đã tiếp nhận hồ sơ',
    WaitKBNNChief: 'Chờ trưởng phòng kiểm soát hồ sơ',
    KBNNChiefReject: 'Trưởng phòng từ chối kiểm soát hồ sơ',
    KBNNChiefApprove: 'Trưởng phòng đã phê duyệt hồ sơ',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
    KBNNDeleted: 'Đã xóa',
  },

  DCSDFileTreasuryStatus_Tooltip: {
    WaitKBNNStaff: 'Chờ Giao dịch viên tiếp nhận hồ sơ',
    KBNNStaffReject: 'Giao dịch viên từ chối tiếp nhận hồ sơ',
    KBNNStaffApprove: 'Giao dịch viên đã tiếp nhận hồ sơ',
    WaitKBNNChief: 'Chờ trưởng phòng kiểm soát hồ sơ',
    KBNNChiefReject: 'Trưởng phòng từ chối kiểm soát hồ sơ',
    KBNNChiefApprove: 'Trưởng phòng đã phê duyệt hồ sơ',
    KBNNReject: 'KBNN từ chối xử lý hồ sơ',
    KBNNDeleted: 'Đã xóa',
  },

  /**
   * Trạng thái giao dịch (Kế toán trưởng)
   */
  FileStatus: {
    CompanyDirectorReject: 'Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'KTT từ chối duyệt',
    Waiting: 'Chờ duyệt',
    FileNotSent: 'Chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Chờ Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Thủ trưởng đã duyệt',
  },

  FileStatus_Tooltip: {
    CompanyDirectorReject: 'Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Waiting: 'Chờ duyệt',
    FileNotSent: 'Chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Chờ Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Thủ trưởng đã duyệt',
  },

  /**
   * Trạng thái giao dịch (Kế toán viên)
   */
  FileStatusAccountant: {
    CompanyDirectorReject: 'Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'KTT từ chối duyệt',
    Waiting: 'Chờ KTT duyệt',
    FileNotSent: 'Chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Chờ Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Thủ trưởng đã duyệt',
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
  },

  FileStatusAccountant_Tooltip: {
    CompanyDirectorReject: 'Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'Kế toán trưởng từ chối duyệt',
    Waiting: 'Chờ Kế toán trưởng duyệt',
    FileNotSent: 'Chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Chờ Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Thủ trưởng đã duyệt',
    FileNotSentToChiefAccountant: 'Chưa gửi duyệt',
  },

  /**
   * Lý do xóa hồ sơ không thành công
   */
  DVCReasonDelete: {
    CompanyDirectorReject: 'Hồ sơ Thủ trưởng từ chối duyệt',
    Waiting: 'Hồ sơ đã được gửi cho KTT duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
    CreatedByChiefAccountant: 'Hồ sơ của Kế toán trưởng tự tạo',
    DelegateDelete: 'Không xóa được do hồ sơ đã được gửi cho ủy quyền KTT duyệt',
  },

  /**
   * Lý do gửi duyệt hồ sơ không thành công
   */
  DVCReasonSendApproval: {
    CompanyDirectorReject: 'Hồ sơ đã được Thủ trưởng từ chối duyệt',
    Waiting: 'Hồ sơ đã được gửi cho KTT duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
    CreatedByChiefAccountant: 'Hồ sơ của Kế toán trưởng tự tạo',
  },

  /**
   * Trạng thái giao dịch (Kế toán trưởng)
   */
  DVCReasonApproval: {
    CompanyDirectorReject: 'Hồ sơ đã được Thủ trưởng từ chối duyệt',
    CompanyChiefAccountantReject: 'Hồ sơ đã được KTT từ chối duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng đã duyệt',
    DelegateReject: 'Hồ sơ đã được gửi cho ủy quyền KTT duyệt',
  },

  /**
   * Lý do từ chối duyệt duyệt hồ sơ không thành công
   */
  DVCReasonReject: {
    CompanyDirectorReject: 'Hồ sơ được Kế toán trưởng tự lập',
    CompanyChiefAccountantReject: 'Hồ sơ đã được KTT từ chối duyệt',
    FileNotSent: 'Hồ sơ chưa gửi Thủ trưởng duyệt',
    WaitingCompanyDirector: 'Hồ sơ đã được gửi cho Thủ trưởng duyệt',
    CompanyDirectorApproved: 'Hồ sơ đã được Thủ trưởng duyệt',
    DelegateReject: 'Không từ chối được do hồ sơ đã được gửi cho ủy quyền KTT duyệt',
  },

  /**
   * Nội dung thanh toán
   */
  PaymentContent: {
    DescriptionDetail: 'diễn giải chi tiết', // Diễn giải chi tiết
    BudgetSubItemName: 'tên tiểu mục', // Tên tiểu mục
    BudgetItemNameAndBudgetSubItemName: 'tên mục + tên tiểu mục', // Tên mục và Tên tiểu mục
    DescriptionVoucher: 'diễn giải chứng từ', // Diễn giải chứng từ
  },
  /**
   * nhóm theo:
   */
  AddGroup: {
    BudgetSubItem: 'tiểu mục',
    BudgetItem: 'mục ',
    BudgetChapter: 'chương',
    Branch: 'ngành',
    BudgetSource: 'nguồn',
  },
  /**
   * Hiển thị ở ?
   */
  AddShow: {
    top: 'hiển thị ở trên',
    bottom: 'hiển thị ở dưới',
  },
  /**
   * hiển thị thêm dòng theo:
   */
  ShowRow: {
    BudgetSourceGroupPropertyType: 'tính chất nguồn',
    DescriptionVoucher: 'diễn giải chứng từ',
  },
  /**
   * Trạng thái hóa đơn
   */
  InvoiceStatusName: {
    Replacement: 'Hóa đơn thay thế',
  },

  /**
   * Trạng thái hồ sơ KBNN
   */
  StateTreasuryStatus: {
    Waiting: 'Chờ KBNN xử lý',
    Completed: 'Đã hoàn thành giao nhận',
    Rejected: 'Từ chối',
  },
  /***
   * Loại nghiệp vụ KB điện tử
   * nthien4 06.10.2022
   */
  DvcVoucher: {
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    CAReceiptWithdraw: 'Rút tiền mặt từ tài khoản tiền gửi',
    EMoneyTransfer: 'Chi chuyển khoản, chuyển tiền điện tử',
    PUInvoice: 'Thanh toán tạm ứng',
    PayFees: 'Nộp trả kinh phí',
    BUVoucherListRealExpense: 'Thanh toán thực chi',
    GLVoucherSummaryTable: 'Bảng tổng hợp chứng từ cùng loại',
    BUVoucherListReceipExpense: 'Bảng kê ghi thu - ghi chi',
    BUInvestmentWithdrawTransfer: 'Rút vốn đầu tư bằng chuyển khoản',
    BUInvestmentWithdrawCash: 'Rút vốn đầu tư bằng tiền mặt',
    BUInvestment: 'Thanh toán vốn đầu tư',
    PaymentSalary: 'Thanh toán lương',
  },

  /***
   * Loại nghiệp vụ KB điện tử (cho kết xuất xml)
   * dtnga3 (22.11.2022)
   */
  DvcVoucherForExportXml: {
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    CAReceiptWithdraw: 'Rút tiền mặt từ tài khoản tiền gửi',
    PaymentSalary: 'Thanh toán lương',
    EMoneyTransfer: 'Chi chuyển khoản, chuyển tiền điện tử',
    PUInvoice: 'Thanh toán tạm ứng',
    BUForeignPlanWithdrawTransfer: 'Rút dự toán ngoại tệ bằng chuyển khoản',
    BUForeignPlanWithdrawCash: 'Rút dự toán ngoại tệ bằng tiền mặt',
    BUInvestmentWithdrawTransfer: 'Rút vốn đầu tư bằng chuyển khoản',
    BUInvestmentWithdrawCash: 'Rút vốn đầu tư bằng tiền mặt',
    BUInvestment: 'Thanh toán vốn đầu tư',
    PayFees: 'Nộp trả kinh phí',
  },

  /**
   * Hình thức kí số
   */
  SignMethod: {
    RemoteSigning: 'Ký bằng Esign', //Ký bằng esign
    USBToken: 'Ký bằng USB token', // Ký bằng usb token
  },

  /**
   * Loại bảng tổng hợp ngày nghỉ/ làm thêm, làm đêm StatisticalTypeTable
   */
  PALayoutTemplate: {
    Luong_canBo: 'Bảng lương cán bộ',
    ChamCong_LamThemGio: 'Làm thêm, làm đêm',
    Luong_ThuNhapKhauTru: 'Bảng tổng hợp thu nhập, khấu trừ',
    TruyLinh_LuongToiThieu: 'Bảng lương truy lĩnh mức lương tối thiểu',
    Luong_BangLuong: 'Bảng lương, phụ cấp',
    Luong_LamThemGio: 'Bảng thanh toán làm đêm, làm thêm giờ',
    SalaryMS09: 'Bảng lương dành cho mẫu 09',
    Luong_TongHop: 'Trả lương',
    ChamCong_NgayNghi: 'Ngày nghỉ',
    Thue_ThangQuy: 'Bảng tính thuế theo tháng, theo quý',
    TruyLinh_LuongCanBo: 'Bảng lương truy lĩnh lương cán bộ',
    Thue_Nam: 'Bảng tính thuế cả nãm',
    Luong_BangLuong_ST: 'Bảng lương, phụ cấp (Mẫu số tiền)',
  },

  SalaryTemplateType: {
    Template: 'Mẫu',
    Designed: 'Tự thiết kế',
  },

  TemplateManageType: {
    Template: 'Mẫu mặc định',
    Designed: 'Mẫu tự thiết kế',
  },

  /**
   * Hình thức hóa đơn
   */
  PaymentMethod: {
    Transfer: 'Chuyển khoản', // Chuyển khoản
    CashKB: 'Tiền mặt tại kho bạc', // Tiền mặt tại kho bạc
    CaskNH: 'Tiền mặt tại ngân hàng', // Tiền mặt tại ngân hàng
  },
  DVCRole: {
    Accountant: 'Kế toán viên',
    ChiefAccountant: 'Kế toán trưởng',
    HeadOfDepartment: 'Thủ trưởng đơn vị',
    DelegateChiefAccountant: 'Ủy quyền kế toán trưởng',
    DelegateHeadOfDepartment: 'Ủy quyền thủ trưởng đơn vị',
  },

  /**
   * Nghị định để load hóa đơn
   */
  InvoiceType: {
    InvoiceWithCode: 'Hóa đơn có mã',
    InvoiceWithoutCode: 'Hóa đơn không mã',
  },

  /***
   * Các báo cáo kho bạc điện tử
   * nthien4 06.10.2022
   */
  DvcReport: {
    C202a_ND11: 'C2-02a/NS',
    C202b_ND11: 'C2-02b/NS',
    C203_ND11: 'C2-03/NS',
    C205a_ND11: 'C2-05a/NS',
    C402b_ND11: 'C402_Currency_ND11',
    C402a_ND11: 'C4-02a/KB',
    C402c_ND11: 'C4-02c/KB',
    M07_ND11: 'Mẫu số 07',

    C206_ND11: 'C206NS_ND11',
    C301_ND11: 'C03_01_ND11',
    C302_ND11: 'C3_02_NS_ND11',

    MS11_ND11: 'MS11_ND11',
    M07_ND11_Portrait: 'Mẫu số 07 dọc',
    M04a_TT_ND99: 'M04a_TT_ND99',
    M04b_TT_ND99: 'M04b_TT_ND99',
    M05_TT_ND99: 'M05_TT_ND99',
    SalaryMS09: 'SalaryMS09',
    SalaryMS09Text: 'Mẫu số 09',
  },

  /**
   * Hiển thị kèm theo (mẫu 07)
   * dqdat1 18.10.2022
   */
  AttachNote: {
    All: 'Tất cả',
    BUPlanWithdraw: 'Giấy rút dự toán',
    Accreditative: 'Ủy nhiệm chi',
    AdvancePaymentRequestLetter: 'Giấy đề nghị thanh toán tạm ứng',
    NoSelect: 'Không chọn',
  },

  /**
   * Hiển thị cột ngày, số chứng từ gốc
   * dqdat1 18.10.2022
   */
  ShowDateAndRefNo: {
    None: 'Không hiển thị',
    NoneWhenInvoice: 'Không hiển thị khi có số hóa đơn',
    DateAndRefNoOld: 'Hiển thị ngày, số chứng từ gốc',
    DateAndRefNo: 'Hiển thị ngày, số chứng từ  ',
    DateAndRefNoBUVoucher: 'Hiển thị ngày, số bảng kê',
  },
  ReportIDDVC: {
    C202a_ND11: 'C2-02a/NS',
    C202b_ND11: 'C2-02b/NS',
    C203_ND11: 'C2-03/NS',
    C205a_ND11: 'C2-05a/NS',
    C402a_ND11: 'C4-02a/KB',
    C402c_ND11: 'C4-02c/KB',
    M07_ND11: 'Mẫu số 07',
    M04a_TT_ND99: 'M04a_TT_ND99',
    M04b_TT_ND99: 'M04b_TT_ND99',
    M05_TT_ND99: 'M05_TT_ND99',
    SalaryMS09: 'SalaryMS09',
    SalaryMS09Text: 'Mẫu số 09',
  },
  ReportNameDVC: {
    M04a_TT_ND99: '04.a/TT',
    M04b_TT_ND99: '04.b/TT',
    M05_TT_ND99: '05/TT',
    SalaryMS09Text: '09',
    SalaryMS09: '09',
  },

  OwnerUnitGrade: {
    EstimateLevelOne: 'Đơn vị dự toán cấp 1',
    IntermediateAccountantFirst: 'Đơn vị kế toán trung gian 1',
    IntermediateAccountantSecond: 'Đơn vị kế toán trung gian 2',
  },

  /**
   * Khóa sổ kỳ kế toán
   * NXCHIEN 24.10.2022
   */
  LockVoucherGroup: {
    ref_type: 'Loại chứng từ',
    ref_date: 'Ngày chứng từ',
    posted_date: 'Ngày hạch toán',
    ref_no: 'Số chứng từ',
    type_edit: 'Hình thức xử lý',
  },

  /**
   * Trạng thái khóa sổ
   * NXCHIEN 24.10.2022
   */
  CloseBookTypeEdit: {
    Post: 'Ghi sổ',
    ChangePostedDate: 'Chuyển ngày HT',
    Remote: 'Xóa',
  },

  /**
   * Hình thức nộp
   * NHANH3 25.10.2022
   */
  PaymentType: {
    Cash: 'Tiền mặt',
    Deposit: 'Tiền gửi',
    Transfer: 'Chuyển khoản kho bạc',
  },

  /**
   * Trạng thái khóa sổ
   * NXCHIEN 24.10.2022
   */
  CloseBookTypeEdit: {
    Post: 'Ghi sổ',
    ChangePostedDate: 'Chuyển ngày HT',
    Remote: 'Xóa',
  },

  SubSystemBusiness: {
    Budget: 'Kho bạc',
    Cashonhand: 'Tiền mặt',
    Cashinbank: 'Tiền gửi',
    Inventory: 'Vật tư hàng hóa',
    Fixedasset: 'Tài sản cố định',
    Salary: 'Tiền lương',
    Sale: 'Bán hàng',
    Purchase: 'Mua hàng',
    Tax: 'Thuế',
    Generalledger: 'Tổng hợp',
    Project: 'Dự án',
    Activity: 'Hoạt động sự nghiệp',
    Tool: 'Công cụ dụng cụ',
    Fund: 'Loại quỹ',
    Inventorysettlement: 'Thanh toán vật tư sử dụng tại trạm y tế',
    Topic: 'Đề tài',
    Investor: 'Chủ đầu tư',
    Task: 'Nhiệm vụ',
    Vaac: 'Đặc thù VAAC',
    Invoice: 'Hóa đơn',
    Contract: 'Hợp đồng',
  },
  ClassificationType: {
    EducationUnit: 'Đơn vị thuộc ngành Giáo dục',
    MedicalUnit: 'Đơn vị thuộc ngành Y tế',
    StateManagementUnitsAndMassOrganization: 'Đơn vị QLNN, Đảng, Đoàn thể',
    OtherUnit: 'Đơn vị Sự nghiệp khác',
  },
  BranchType: {
    Medical: 'Y tế',
    Education: 'Giáo dục',
  },

  /**
   * Kinh phí trong tham số in báo cáo
   * NVTUAN1 02.11.2022
   */
  SourceKindType: {
    TX: 'Kinh phí thường xuyên',
    KTX: 'Kinh phí không thường xuyên',
    XDCB: 'Kinh phí xây dựng cơ bản',
  },

  /**
   * Nội dung hạch toán lương
   * NNLINH 14.11.2022
   */
  PayrollExpenseType: {
    ExpenseAll: 'Hạch toán toàn bộ lương phát sinh',
    ExpenseSalary: 'Hạch toán trên số lương đã trừ các khoản bảo hiểm, kinh phí công đoàn, thuế TNCN',
    ExpenseInsurance: 'Hạch toán bảo hiểm',
    ExpenseLaborFee: 'Hạch toán kinh phí công đoàn',
    ExpenseTax: 'Hạch toán thuế TNCN',
  },
  /**
   * Kích thước trang báo cáo
   * PQDat 14.11.2022
   */
  PageSize: {
    A4: 'A4',
    A3: 'A3',
  },

  /**
   * Giá trị combobox đọc số tiền cột form tham số in chứng từ C02-HD lương
   * NHANH3 22.11.2022
   */
  ReadAmountColumn: {
    BHXHCQ: 'Trích vào CP - BHXH',
    BHYTCQ: 'Trích vào CP - BHYT',
    BHTNCQ: 'Trích vào CP - BHTN',
    KPCDCQ: 'Trích vào CP - KPCD',
    BHXH: 'Trừ vào lương - BHXH',
    BHYT: 'Trừ vào lương - BHYT',
    BHTN: 'Trừ vào lương - BHTN',
    KPCD: 'Trừ vào lương - KPCD',
    REALVALUE: 'Số thực lĩnh',
    NONE: 'Không chọn',
  },
  AdvanceFundType: {
    AdvancePaymentInvest: 'Tạm ứng vốn đầu tư',
    AdvanceInvest: 'Ứng trước vốn đầu tư',
  },
  /**
   *  Loại thanh toán
   *  ncdinh 24.11.2022
   */
  TypeOfPayment: {
    InvestmentAdvance: 'Tạm ứng vốn đầu tư',
    AdvanceInvestment: 'Ứng trước vốn đầu tư',
  },
  /**
   *  Loại thanh toán
   *  TPNAM 09.12.2022
   */
  DecreaseReasonType: {
    Liquidation: 'Thanh lý',
    Transfer: 'Điều chuyển',
    Auction: 'Bán đấu giá',
    DesignatedSale: 'Bán chỉ định',
    Assign: 'Chuyển nhượng',
    Missing: 'Mất',
    Destroy: 'Tiêu hủy',
    AnotherForm: 'Hình thức khác',
  },
  /**
   *  Loại thanh toán cho báo cáo
   *  TBNGOC 30.03.2023
   */
  DecreaseReasonTypeReport: {
    Liquidation: 'Thanh lý',
    Transfer: 'Điều chuyển',
    Auction: 'Bán đấu giá',
    DesignatedSale: 'Bán chỉ định',
    Assign: 'Chuyển nhượng',
    Missing: 'Mất',
    Destroy: 'Tiêu hủy',
    AnotherForm: 'Hình thức khác',
    Summary: 'Tổng hợp',
  },
  /**
   * Tên khoản tạm thu
   *  pqkhanh 08.12.2022
   */
  TempCollection: {
    All: '<<Tất cả>>',
    Summary: '<<Tổng hợp>>',
    ExpenseCash: 'Kinh phí hoạt động bằng tiền',
    ForeignDebt: 'Viện trợ, vay nợ nước ngoài',
    TempFees: 'Tạm thu phí, lệ phí',
    AdvanceEstimate: 'Ứng trước dự toán',
    OrtherTempCollection: 'Tạm thu khác',
  },
  /* Nguồn hình thành TS cố định
   * NNKIEM 09.12.2022
   */
  SourceTypeFixedAsset: {
    StateBudget: 'Nguồn NSNN Cấp',
    ForeignDebt: 'Nguồn viện trợ, vay nợ nước ngoài',
    FeeLeave: 'Nguồn phí được khấu trừ, để lại',
    WelfareFund: 'Quỹ phúc lợi',
    CareerActivitie: 'Quỹ phát triển hoạt động sự nghiệp',
    BusinessCapital: 'Nguồn vốn kinh doanh',
    OtherSource: 'Nguồn khác',
  },
  /**
   * Kỳ tính khấu hao
   * NNKIEM 09.12.2022
   */
  DevaluationPeriod: {
    Month: 'Tháng',
    Quarter: 'Quý',
  },

  /***
   * Các báo cáo chọn trên màn đối chiếu số dư KBĐT
   * nthien4 15.10.2022
   */
  DcsdReport: {
    N01a_SDKP_DVDT_ND112020:
      'Mẫu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước',
    N02a_SDKP_DVDT_ND112020:
      'Mẫu số 02a-SDKP/ĐVDT: Bảng đối chiếu tình hình sử dụng kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước',
    ReportMS04: 'Mẫu số 04-SDKP/ĐVDT: Tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau',
    CashInBankConfirmation:
      'Mẫu số 06-ĐCSDTK/KBNN: Bảng xác nhận số dư tài khoản tiền gửi tại KBNN (Nghị định 11/2020/NĐ-CP)',
  },
  BudgetDistributionCode: {
    Distribution0: '0',
    Distribution1: '1',
    Distribution2: '2',
    Distribution3: '3',
    Distribution4: '4',
  },
  EstimatesType: {
    Official: 'Dự toán chính thức',
    Advance: 'Dự toán ứng trước',
  },
  /**
   *  Tên khoản tạm thu
   *  pqkhanh 08.12.2022
   */
  TempCollection: {
    All: '<<Tất cả>>',
    Summary: '<<Tổng hợp>>',
    ExpenseCash: 'Kinh phí hoạt động bằng tiền',
    ForeignDebt: 'Viện trợ, vay nợ nước ngoài',
    TempFees: 'Tạm thu phí, lệ phí',
    AdvanceEstimate: 'Ứng trước dự toán',
    OrtherTempCollection: 'Tạm thu khác',
  },

  FixedAssetStatistic: {
    TT_107: 'Mẫu thông tư 107/2017/TT-BTC',
    Category_FixedAsset: 'Mẫu theo loại tài sản cố định (hiển thị riêng tài sản Đất đai)',
  },
  /**
   * Enum mục đích sử dụng S24-H: Sổ tài sản cố định
   * DDTHANG 26/12/2022
   */
  S24HUsesType: {
    Summary: 'Tổng hợp',
    All: 'Tất cả',
    Shared: 'Dùng chung',
    BusinessAndService: 'Hoạt động SXKD, dịch vụ',
    AdministrativeCareer: 'Hoạt động hành chính, sự nghiệp',
  },

  S24HQuantity: {
    ShowQuantity: 'Hiển thị số lượng trên Sổ',
    HideQuantity: 'Không hiển thị số lượng trên Sổ',
  },

  /**
   * loại tờ khai giá trị gia tăng
   * tvhien 03.01.2023
   */
  CircularVATType: {
    VATFirst: 'Tờ khai lần đầu',
    VATAdditional: 'Tờ khai bổ sung',
  },

  /**
   * Thông tư áp dụng cho phân hệ thuế - tờ khai giá trị gia tăng
   * tvhien 03.01.2023
   */
  ApplicableCircular: {
    TT80: 'TT 80/2021/TT-BTC',
  },
  /**
   * Danh mục ngành nghề
   * tvhien 05/01/2023
   */
  Occupation: {
    ActivityManufact: 'Hoạt động sản xuất kinh doanh thông thường',
    ActivityLottery: 'Hoạt động xổ số kiến thiết, xổ số điện toán',
    ActivityProbe: 'Hoạt động thăm dò khai thác dầu khí',
    InvestmentProject: 'Dự án đầu tư cơ sở hạ tầng, nhà để chuyển nhượng khác địa bàn tỉnh nơi đóng trụ sở chính',
    FactoryElectrict: 'Nhà máy sản xuất điện khác địa bàn tỉnh nơi đóng trụ sở chính',
  },

  /**
   * Nhóm ngành nghề chính tính thuế GTGT
   * NHANH3 13.05.2024
   */
  TaxCalculationOccupation: {
    ServiceFreeTax: 'Hàng hóa, dịch vụ không chịu thuế GTGT hoặc hàng hóa, dịch vụ áp dụng thuế suất 0%',
    ProvideItem: 'Phân phối, cung cấp hàng hóa áp dụng thuế suất 1%',
    ConstructionNotIncludeMaterials: 'Dịch vụ, xây dựng không bao thầu nguyên vật liệu áp dụng thuế suất 5%',
    ConstructionIncludeMaterials:
      'Sản xuất, vận tải, dịch vụ có gắn với hàng hóa, xây dựng có bao thầu nguyên vật liệu áp dụng thuế suất 3%',
    OtherService: 'Hoạt động kinh doanh khác áp dụng thuế suất 2%',
  },

  /**
   * Danh mục trường hợp quyết toán
   * NHANH3 29.03.2024
   */
  Finalization: {
    Periodic: 'QT định kỳ',
    Reorganization: 'Tổ chức lại doanh nghiệp',
    ConvertType: 'Chuyển đổi loại hình (đối với trường hợp CPH DNNN)',
    ConvertFiscalPeriod: 'Chuyển đổi kỳ tài chính',
    Dissolution: 'Giải thể, phá sản',
    Terminate: 'Chấm dứt hoạt động, chấm dứt hợp đồng',
  },

  // Enum các loại phụ lục tờ khai thuế
  VatAppendixType: {
    TaSaleListIn: 'Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào', // Bảng kê hàng hóa mua vào
    TaSaleListOut: 'Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ bán ra', //Bảng kê hàng hóa bán ra
    TaPL01KHBS: 'Tờ khai bổ sung', //Phụ lục tờ khai bổ sung
    TaPL011KHBS: 'Bản giải trình khai bổ sung', //Phụ lục giải trình khai bổ sung
    Ta432022QH15: 'Giảm thuế giá trị gia tăng theo Nghị quyết 43/2022/QH15', //Phụ lục theo Nghị quyết 43/2022/QH15
  },

  /**
   * Loại chứng từ dùng cho tiện ích Sắp xếp lại số CT
   * dtnga3 (06.01.2023)
   */
  SortRefTypeGroup: {
    BUPlan: 'Nhận dự toán',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    BUPlanWithdraw: 'Rút dự toán',
    BUTransfer: 'Chuyển khoản kho bạc',
    CAReceipt: 'Phiếu thu',
    CAPayment: 'Phiếu chi',
    BADeposit: 'Thu tiền gửi',
    BAWithdraw: 'Chi tiền gửi',
    BATransfer: 'Tiền đang chuyển',
    INInward: 'Nhập kho',
    INOutward: 'Xuất kho',
    INTransfer: 'Chuyển kho',
    INAdjustment: 'Điều chỉnh tồn kho',
    SUIncrement: 'Ghi tăng công cụ dụng cụ',
    SUDecrement: 'Ghi giảm công cụ dụng cụ',
    SUTransfer: 'Điều chuyển công cụ dụng cụ',
    FAIncrement: 'Ghi tăng tài sản cố định',
    FADecrement: 'Ghi giảm tài sản cố định',
    FAAdjustment: 'Đánh giá lại tài sản cố định',
    FATransfer: 'Điều chuyển phòng/ban',
    PUInvoice: 'Hóa đơn mua hàng, tài sản',
    SAInvoice: 'Hóa đơn bán hàng',
    GLGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    BUVoucherList: 'Bảng kê chứng từ thanh toán',
    BUPlanCancel: 'Hủy dự toán',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh tạm ứng',
    BURealExpenseAdjustment: 'Điều chỉnh thực chi',
    BABankTransfer: 'Chuyển tiền nội bộ',
    SAReturn: 'Hàng bán trả lại',
    GLProvisionalTaxInComeEnterprise: 'Tạm tính thuế thu nhập doanh nghiệp',
    GLFinalTaxInComeEnterprise: 'Quyết toán thuế thu nhập doanh nghiệp',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDepreciation: 'Hao mòn TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    GLPostedVoucher: 'Chứng từ ghi sổ',
  },
  PeriodPeculiarity: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    Year: 'Năm',
  },
  PeriodMonthQuarter: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
  },
  /**
   * Map table với module dùng cho invalid cache
   * TVDAT 15/02/2023
   */
  TableMapModule: {
    di_account: 'account',
    di_account_transfer: 'accountTransfer',
    sys_ref_type: 'defaultAccount',
    di_account_parallel_rule: 'accountParallelRule',
    di_account_parallel_rule_detail: 'accountParallelRule',
    di_auto_business: 'autoBusiness',
    di_budget_chapter: 'budgetChapter',
    di_budget_kind_item: 'budgetKindItem',
    di_budget_item: 'budgetItem',
    di_budget_source: 'budgetSource',
    di_budget_source_property: 'budgetSourceProperty',
    di_project: 'project',
    di_budget_provide: 'budgetProvide',
    di_fund: 'typeOfFund',
    di_currency: 'currency',
    di_bank_info_category: 'bankInfoCategory',
    di_bank_info: 'bankInfo',
    di_accounting_object_category: 'accountingObjectCategory',
    di_accounting_object_employee: 'accountingObject',
    di_accounting_object_customerVendor: 'customerVendor',
    di_fixed_asset: 'fixedAssetCache',
    di_fixed_asset_category: 'fixedAssetCategory',
    di_department: 'department',
    di_employee_type: 'employeeType',
    di_payroll_item: 'payrollItem',
    di_salary_scale: 'salaryScale',
    inventory_item: 'inventoryItem',
    di_inventory_category: 'inventoryCategory',
    di_stock: 'stock',
    di_purchase_purpose: 'purchasePurpose',
    di_invoice_form_number: 'invoiceFormNumber',
    di_voucher_type: 'voucherType',
    di_budget_fees: 'budgetFees',
    di_task: 'task',
    di_topic: 'topic',
    di_activity: 'activity',
    di_fund_structure: 'fundStructure',
    di_statistic: 'statistic',
    di_budget_group_item: 'budgetGroupItem',
    di_contract: 'contract',
    di_inventory_item: 'inventoryItem',
    di_tool_inventory_category: 'toolType',
    di_auto_business_detail: 'autoBusiness',
    di_auto_business_detail_parallel: 'autoBusiness',
  },
  MenuAuditTypeCombo: {
    All: 'Tất cả',
    UnrecordDocument: '1. Chứng từ chưa ghi sổ',
    CashDeposit: '2. Tiền mặt, tiền gửi',
    AuditInventory: '3. Kho',
    FixedAsset: '4. Tài sản cố định',
    AdvanceVoucher: '5. Chứng từ chưa thanh toán tạm ứng',
    VoucherParalell: '6. Hạch toán tài chính và hạch toán ngoài bảng',
    AuditWithDrawBudget: '7. Sổ rút và chi theo mục lục ngân sách',
    AuditSalary: '8. Tài khoản lương và các khoản trích theo lương',
    AuditAnomalyBusiness: '9. Nghiệp vụ bất thường',
    AuditMovementBalance: '10. Bảng cân đối phát sinh',
    AuditFinancial: '11. Báo cáo tài chính',
    AuditSettlement: '12. Báo cáo quyết toán',
  },
  BackupStatus: {
    Success: 'Sao lưu thành công', // sao lưu thành công
    WaitingBackup: 'Đang sao lưu', // đang sao lưu
    Error: 'Sao lưu thất bại', // sao lưu thất bại
    Expiration: 'Quá hạn phục hồi', // quá hạn
    CancelBackup: 'Đang hủy sao lưu', // đang bấm hủy sao lưu
    WaitingRestore: 'Đang phục hồi', // đang sao lưu
    CancelRestore: 'Đang hủy phục hồi', // đang bấm hủy phục hồi
  },
  BackupStoreStatus: {
    Success: 'Lưu trữ thành công', // lưu trữ thành công
    WaitingBackup: 'Đang lưu trữ', // đang lưu trữ
    Error: 'Lưu trữ thất bại', // lưu trữ thất bại
    Expiration: 'Quá hạn phục hồi', // quá hạn
    CancelBackup: 'Đang hủy lưu trữ', // đang bấm hủy lưu trữ
    WaitingRestore: 'Đang phục hồi', // đang lưu trữ
    CancelRestore: 'Đang hủy phục hồi', // đang bấm hủy phục hồi
  },
  DatabaseStatus: {
    ShowInClient: 'Hiển thị trên giao diện người dùng',
    NotShowInClient: 'Không hiển thị trên giao diện người dùng',
    Restoring: 'Đang phục hồi',
    Backuping: 'Đang sao lưu',
    Error: 'Dữ liệu lỗi',
  },
  DbHistoryTypeAction: {
    Backup: 'Sao lưu dữ liệu',
    Restore: 'Phục hồi dữ liệu',
    Add: 'Thêm mới dữ liệu',
    AddFromPreviousYear: 'Thêm mới dữ liệu từ năm trước',
    Rename: 'Đổi tên dữ liệu',
    Delete: 'Xóa dữ liệu',
    Store: 'Lưu trữ dữ liệu',
    DeleteStore: 'Xóa dữ liệu lưu trữ',
    ConversionOfAccountingSystem: 'Cập nhật TT 24/2024/TT-BTC',
  },
  /**
   * Enum trả về các trường hợp đồng bộ danh mục
   * pqkhanh 21.03.2023
   */
  OptionSyncDictionary: {
    //Lỗi
    Error: -1,
    //Không có Bumas
    NoBumas: 1,
    //Không có mimo tự thêm và không có phát sinh hạch toán
    NoMimosaNoArise: 2,
    // có mimosa, có bumas nhưng không có phát sinh hạch toán
    HaveMimosaHaveBumasNoArise: 3,
    // Đã có phát sinh hạch toán
    HaveArise: 4,
  },

  EmployeeRole: {
    Chairman: 'Trưởng ban',
    Commissioner: 'Ủy viên',
  },
  /**
   * Enum trạng thái gửi số liệu sang Bumas
   * bqdiep 21.03.2023
   */
  StatusSenDictionary: {
    //Chưa phát sinh số thực hiện
    NotIncurred: 1,
    // Chưa đồng bộ danh mục
    NotSyncDictionary: 2,
    // Chưa đồng bộ nguồn
    NotSyncBudgetSource: 3,
    // Chứng từ chưa chọn nhiệm vụ
    NotSelectMission: 4,
    // thất bại
    Error: 5,
    // thành công
    Success: 6,
    // Không có danh mục
    NodataDictionary: 7,
  },
  /* loại phần mềm bumas
   * pqkhanh 21.03.2023
   */
  BumasAppType: {
    BumasTW: 1,
    BumasDP: 2,
    BumasKTNN: 3,
  },
  DictionarySendBumas: {
    BudgetFees: 'BudgetFees', // phí, lệ phí
    Mission: 'Mission', // Nhiệm vụ
    Project: 'Project', // CTMT, dự án
    Active: 'Active', // Hoạt động
  },
  CreReportSubmitStatus: {
    // Cần sửa lại
    NeedToCorrect: 'Cần sửa lại',
    // Chờ nhận báo cáo
    WaitingReport: 'Chờ nhận báo cáo',
    // Đã nộp báo cáo
    Submited: 'Đã nộp báo cáo',
    // Đã nộp lại báo cáo
    ReSubmited: 'Đã nộp lại báo cáo',
    // Đã đồng ý
    Accepted: 'Đã đồng ý',
    // Đã ra biên bản
    RecordMade: 'Đã ra biên bản',
    // Đã ra thông báo
    ReportMade: 'Đã ra thông báo',
  },
  /**
   * Trạng thái biên lai
   * tvhien 07.04.2023
   */
  ReceiptStatus: {
    OriginalInvoice: 'Biên lai gốc', //(Hóa đơn gốc)
    DeletedInvoice: 'Biên lai xóa bỏ', //(Xóa bỏ)
    ReplaceInvoice: 'Biên lai thay thế', //(Thay thế)
    AdjustInvoice: 'Biên lai điều chỉnh', //(Điều chỉnh)
  },
  /**
   * Lọc chứng từ khi chọn chứng từ in
   * nvtoan2 4/04/2023
   */
  ReportSettingVoucherFilter: {
    All: 'Tất cả',
    UnPrint: 'Chưa in',
    Printed: 'Đã in',
  },
  /**
   * Lọc chứng từ khi chọn chứng từ in
   * nvtoan2 4/04/2023
   */
  ReportSettingTimeFilter: {
    RefDate: 'Lọc theo ngày chứng từ',
    PostedDate: 'Lọc theo ngày hạch toán',
  },
  X1ReportStatus: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
  },
  CreReportSubmitStatus: {
    Unsend: 'Chưa nộp báo cáo',
    NeedToCorrect: 'Cần sửa lại',
    WaitingReport: 'Chờ nhận báo cáo',
    Submited: 'Đã nộp báo cáo',
    ReSubmited: 'Đã nộp lại báo cáo',
    Accepted: 'Đã đồng ý',
    RecordMade: 'Đã ra biên bản',
    ReportMade: 'Đã ra thông báo',
  },

  /**
   * hạch toán không có option tất cả
   * tvhien 13.04.2023
   */
  IsPostedReceipt: {
    UnPosted: 'Chưa hạch toán',
    Posted: 'Đã hạch toán',
  },
  AccountingObjectGroup: {
    PublicServants: 'CB/Công chức',
    Functionary: 'Viên chức',
    ContractLabor: 'LĐHĐ',
  },

  SuggestionPaymentType: {
    Advance: 'Tạm ứng',
    Payment: 'Thanh toán',
  },
  /**
   * Phân bổ
   * TPNAM 15.05.2023
   */
  AllocationConfig: {
    NoAllocation: 'Không phân bổ',
    QuarterlyAllocation: 'Phân bổ theo quý',
    MonthlyAllocation: 'Phân bổ theo tháng',
  },
  /**
   * Combo Xem theo trên biểu đồ
   * TVANH 22.06.2023
   */
  DashboardViewOption: {
    Assigned: 'Số dự toán được giao',
    ActuallyReceived: 'Số dự toán thực nhận',
  },

  /**
   * enum tên thông tư
   * VQDUC 02.08.2023
   */
  Circulars: {
    Circulars2024: 'Thông tư 24/2024/TT-BTC về Chế độ kế toán hành chính, sự nghiệp',
    Circulars2017: 'Thông tư 107/2017/TT-BTC về Chế độ kế toán Hành chính sự nghiệp',
  },

  /**
   * Enum trạng thái vé điện tử
   * NNLINH 31.08.2023
   */
  ElectronicTicket: {
    OriginalTicket: 'Vé mới',
    DeletedTicket: 'Vé bị hủy',
    ReplaceTicket: 'Vé thay thế',
    AdjustTicket: 'Vé điều chỉnh',
    ReplacedTicket: 'Vé đã bị thay thế',
    AdjustedTicket: 'Vé đã bị điều chỉnh',
  },

  /**
   * Trạng thái kết quả đồng bộ dữ liệu
   */
  SynchronousResultType: {
    Success: 'Cất thành công',
    Fail: 'Cất không thành công',
  },

  /**
   * trạng thái kiểm tra hóa đơn
   */
  InvoiceBotType: {
    WaitChecking: 'Chờ kiểm tra',
    Valid: 'Hợp lệ',
    Invalid: 'Cảnh báo',
  },

  /**
   * trạng thái hóa đơn ở bên inBot
   */
  InvoiceBotStatusType: {
    Root: 'Hóa đơn mới',
    Replace: 'Hóa đơn thay thế',
    Adjustment: 'Hóa đơn điều chỉnh',
    Replaced: 'Hóa đơn đã bị thay thế',
    Adjustmented: 'Hóa đơn đã bị điều chỉnh',
    Deleted: 'Hóa đơn đã bị hủy bỏ',
    Unknown: 'Hóa đơn chưa xác định',
  },

  /**
   * trạng thái lập chứng từ
   */
  IsInbotPosted: {
    UnPosted: 'Chưa lập',
    Posted: 'Đã lập',
  },

  /**
   * Enum các chức năng trên chương trình
   * NVTUAN1 15.12.2023
   */
  Command: {
    UnPosted: 'Bỏ ghi chứng từ',
    Posted: 'Ghi sổ chứng từ',
    ImportVoucher: 'Nhập khẩu chứng từ',
    BackupData: 'Sao lưu dữ liệu',
    UpdateCircular: 'Cập nhật thông tư',
    LockVoucher: 'Khóa sổ kỳ kế toán',
    DataMaintaince: 'Bảo trì dữ liệu',
    SendAccountingData: 'Xuất khẩu dữ liệu',
    PayStatements: 'Thanh toán bảng kê',
    CancelPayStatements: 'Hủy thanh toán bảng kê',
    UnPostBatch: 'Bỏ ghi theo lô',
    PostBatch: 'Ghi sổ theo lô',
    SortRefNo: 'Sắp xếp lại số chứng từ',
    CalclnInOutward: 'Tính giá xuất kho',
    SaveOpeningAccount: 'Nhập số dư ban đầu',
    AccountTransfer: 'Chuyển tài khoản hạch toán',
    BudgetSourceTransfer: 'Chuyển nguồn',
    BudgetKindItemTransfer: 'Chuyển loại - khoản hạch toán',
    ProjectTransfer: 'Chuyển CTMT, Dự án',
    CreateDataPrevYear: 'Tạo mới dữ liệu từ năm trước',
    Copy: 'Sao chép dữ liệu',
    ConvertDesktop: 'Chuyển đổi dữ liệu',
    StorageData: 'Lưu trữ dữ liệu',
    Edit: 'Sửa',
    Add: 'Thêm',
    DeleteOpeningAccount: 'Xóa số dư ban đầu',
    ViewInvoiceDetail: 'Xem chi tiết hóa đớn',
  },
  /**
   * Enum trạng thái hoạt động/ngừng hoạt động của MST
   * TPNAM 31.01.2024
   */
  TaxActiveStatus: {
    Active: 'NNT đang hoạt động (đã được cấp GCN ĐKT)', // đang hoạt động
    NotActive: 'NNT ngừng hoạt động và đã đóng MST', // ngừng hoạt động
    ChangedAgency: 'NNT đã chuyển cơ quan thuế quản lý', // đang hoạt động
    NotActiveButNotCompleteProcedure: 'NNT ngừng hoạt động nhưng chưa hoàn thành thủ tục đóng MST', // ngừng hoạt động
    NotActiveButNotCompleteProcedureDN: 'DN ngừng hoạt động nhưng chưa hoàn thành thủ tục đóng MST',
    ActiveNotification: 'NNT đang hoạt động (được cấp thông báo MST)', // đang hoạt động
    TemporaryBreakBusiness: 'NNT tạm nghỉ kinh doanh có thời hạn', // đang hoạt động
    NotActiveInAddress: 'NNT không hoạt động tại địa chỉ đã đăng ký', // đang hoạt động
    WaitingProcedure: 'NNT chờ làm thủ tục phá sản', // ngừng hoạt động
  },
  /**
   * Enum văn bản quy định
   * TPNAM 02.02.2024
   */
  RegulatoryDocuments: {
    Document1798: 'Công văn số 1798/TCT-TTKT ngày 16/05/2023',
    Document12111: 'Công văn số 12111/CTTPHCM-TTKT2 ngày 06/10/2023',
    Document4729: 'Công văn số 4729/CTHPH-TTKT1 ngày 31/08/2023',
    Document2387: 'Công văn số 2387/CCT-KT2 ngày 18/04/2023',
  },
  /**
   * Enum câu cảnh báo tương ứng với từng loại công văn
   * TPNAM 02.02.2024
   */
  WarningCorrespondingDocument: {
    WarningDocument1798: 'Doanh nghiệp in, phát hành, mua bán trái phép hóa đơn.',
    WarningDocument12111: 'Doanh nghiệp bán hóa đơn.',
    WarningDocument4729:
      'Doanh nghiệp không hoạt động tại địa chỉ đăng ký kinh doanh, không có hóa đơn điện tử của hàng hóa dịch vụ mua vào, có rủi ro cao về thuế và hóa đơn.',
    WarningDocument2387: 'Doanh nghiệp in, phát hành, mua bán trái phép hóa đơn.',
  },

  EventType: {
    ClosePopupCheckReportB01: 'Đóng popup kiểm tra báo cáo B01',
    ClosePopupCheckReportS05H: 'Đóng popup kiểm tra báo cáo S05H',
  },
  AccountExistError: {
    AllNotExistError: 'AllNotExistError',
    APartNotExistError: 'APartNotExistError',
  },
  MailSupplier: {
    Gmail1: 'Gmail1',
    Gmail2: 'Gmail2',
    Hotmail: 'Hotmail',
    OutlookMail: 'Outlook Mail',
    YahooMail1: 'Yahoo Mail1',
    YahooMail2: 'Yahoo Mail2',
    Other: 'Khác',
  },
  MailSecurityMethod: {
    None: 'Không',
    Ssl: 'SSL',
    Tls: 'TLS',
  },
  // Nhóm ngành nghề
  IndustryGroupRate: {
    ZeroPercent: '0%',
    OnePercent: '1%',
    TwoPercent: '2%',
    ThreePercent: '3%',
    FivePercent: '5%',
  },
  // Cảnh báo thỏa thuận mua hàng
  AgreementPurchase: {
    TittleAgreementPurchase: 'Chưa xác nhận Thỏa thuận mua hàng',
    WarningAgreementPurchase:
      '{0} chưa xác nhận Thỏa thuận mua hàng. Vui lòng liên hệ với Quản trị hệ thống để xác nhận.',
  },
};
